// This file is auto-generated by @hey-api/openapi-ts

export const $Subtenant = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            example: 'Sales App',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        badgeColor: {
            type: 'string',
            example: '#cecdcc'
        },
        description: {
            type: 'string',
            nullable: true,
            example: 'Sales team subtenant',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        childrenCount: {
            type: 'integer',
            minimum: 0,
            description: 'Number of child subtenants',
            example: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        subtenantLevel: {
            type: 'integer',
            minimum: 0,
            maximum: 4,
            description: 'The level of the subtenant in the hierarchy (0-4)',
            example: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0,max=4'
            }
        },
        parent: {
            type: 'object',
            nullable: true,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                }
            },
            required: ['id', 'name'],
            example: {
                id: '1234',
                name: 'Sales App'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        children: {
            type: 'array',
            nullable: true,
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    name: {
                        type: 'string',
                        example: 'Sales App'
                    }
                },
                required: ['id', 'name']
            },
            example: [
                {
                    id: '1234',
                    name: 'Sales App'
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'tenantID', 'name', 'description', 'childrenCount', 'subtenantLevel', 'parent', 'children'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $Pagination = {
    type: 'object',
    properties: {
        currentPage: {
            type: 'integer',
            minimum: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        pageSize: {
            type: 'integer',
            minimum: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        totalItems: {
            type: 'integer',
            minimum: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        totalPages: {
            type: 'integer',
            minimum: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        }
    },
    required: ['currentPage', 'pageSize', 'totalItems', 'totalPages'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $SubtenantsFilter = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Sales App'
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '19c0b4f0-2d3e-4a1b-bc7f-5a8e9d6f8b2c'
        },
        hasChildren: {
            type: 'boolean',
            description: 'Filter by whether subtenant has children',
            example: false
        },
        subtenantLevel: {
            type: 'integer',
            minimum: 0,
            maximum: 4,
            description: 'Filter by subtenant level in hierarchy',
            example: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=0,max=4'
            }
        }
    },
    example: {
        name: 'Sales App',
        hasChildren: false
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $SubtenantsSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-subtenantLevel', '+subtenantLevel']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -subtenantLevel +subtenantLevel'
    },
    additionalProperties: false
} as const;

export const $PaginatedSubtenantsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/SubtenantsFilter'
        },
        sort: {
            '$ref': '#/components/schemas/SubtenantsSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedSubtenantsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Subtenant'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedSubtenantsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $FlatSubtenant = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            example: 'Sales App',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        badgeColor: {
            type: 'string',
            example: '#cecdcc'
        },
        description: {
            type: 'string',
            nullable: true,
            example: 'Sales team subtenant',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        childrenCount: {
            type: 'integer',
            minimum: 0,
            description: 'Number of child subtenants',
            example: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        subtenantLevel: {
            type: 'integer',
            minimum: 0,
            maximum: 4,
            description: 'The level of the subtenant in the hierarchy (0-4)',
            example: 0,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0,max=4'
            }
        },
        parent: {
            type: 'object',
            nullable: true,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                }
            },
            required: ['id', 'name'],
            example: {
                id: '1234',
                name: 'Sales App'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'tenantID', 'name', 'description', 'childrenCount', 'subtenantLevel', 'parent'],
    additionalProperties: false
} as const;

export const $PaginatedFlatSubtenantsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/SubtenantsFilter'
        },
        sort: {
            '$ref': '#/components/schemas/SubtenantsSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedFlatSubtenantsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FlatSubtenant'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedFlatSubtenantsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $SubtenantsResponse = {
    anyOf: [
        {
            '$ref': '#/components/schemas/PaginatedSubtenantsResponse'
        },
        {
            '$ref': '#/components/schemas/PaginatedFlatSubtenantsResponse'
        }
    ],
    additionalProperties: false
} as const;

export const $ValidationError = {
    type: 'object',
    properties: {
        field: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['field', 'message'],
    additionalProperties: false
} as const;

export const $ErrorResponse = {
    type: 'object',
    properties: {
        status: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ValidationError'
            }
        }
    },
    required: ['status', 'message'],
    additionalProperties: false
} as const;

export const $SubtenantResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Subtenant'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateSubtenant = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Sales App',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        badgeColor: {
            type: 'string',
            example: '#cecdcc'
        },
        description: {
            type: 'string',
            example: 'Sales team subtenant'
        },
        subtenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'Parent subtenant ID',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    required: ['name'],
    additionalProperties: false
} as const;

export const $PatchSubtenant = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Sales App'
        },
        badgeColor: {
            type: 'string',
            example: '#cecdcc'
        },
        description: {
            type: 'string',
            example: 'Sales team subtenant'
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'Parent subtenant ID. Set to null to remove parent.',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    additionalProperties: false
} as const;

export const $SubtenantMember = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        displayName: {
            type: 'string',
            example: 'John Doe',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john@mimic.com',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        role: {
            type: 'string',
            enum: ['none', 'viewer', 'editor', 'admin'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=none viewer editor admin'
            }
        }
    },
    required: ['id', 'displayName', 'email', 'role'],
    additionalProperties: false
} as const;

export const $SubtenantMemberFilter = {
    type: 'object',
    properties: {
        displayName: {
            type: 'string',
            example: 'John Doe'
        }
    },
    example: {
        displayName: 'John Doe'
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $SubtenantMembersSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-displayName', '+displayName']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-displayName +displayName'
    },
    additionalProperties: false
} as const;

export const $SubtenantMembersResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/SubtenantMemberFilter'
        },
        sort: {
            '$ref': '#/components/schemas/SubtenantMembersSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $SubtenantMembersResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/SubtenantMember'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/SubtenantMembersResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $UpdateSubtenantMembership = {
    type: 'object',
    properties: {
        role: {
            type: 'string',
            enum: ['none', 'viewer', 'editor', 'admin', 'inherit'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=none viewer editor admin inherit'
            }
        }
    },
    required: ['role'],
    additionalProperties: false
} as const;

export const $Token = {
    type: 'object',
    properties: {
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        token: {
            type: 'string',
            example: 'SFMyNTY.ZDE0Mjk0YTEtMzdjMy00YTI2LWE3YUtZTMwMThjOTg5Y2M4.j651kUiwfWTiJRBCBH2_UsEPtH7oxhFja4u6lDbKB8F',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstName: {
            type: 'string',
            example: 'John',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastName: {
            type: 'string',
            example: 'Wilkinson',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john.wilkinson@mimic.com',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tenantID', 'token', 'firstName', 'lastName', 'email'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Token'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $UserInfo = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        type: {
            type: 'string',
            enum: ['user', 'api-token', 'm2m-client'],
            default: 'user',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,oneof=user api-token m2m-client'
            }
        },
        displayName: {
            type: 'string',
            example: 'John Doe',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john@somewhere.com',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'displayName', 'email'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CreateApiTokenData = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 30,
            example: 'CI pipeline',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=30'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        permissions: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: 'Permissions granted to this API token',
            example: ['node-configs:create', 'users:read', 'nodes:read'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revokedBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateRevoked: {
            type: 'string',
            format: 'date-time'
        },
        token: {
            type: 'string',
            example: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'name', 'tenantId', 'permissions', 'createdBy', 'dateCreated', 'token'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CreateApiTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CreateApiTokenData'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateToken = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 30,
            example: 'CI pipeline',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=30'
            }
        },
        permissions: {
            type: 'array',
            items: {
                type: 'string',
                pattern: '^[a-z0-9_-]+:[a-z0-9_-]+$'
            },
            minItems: 1,
            description: 'Array of permissions to grant to the API token (required, minimum 1)',
            example: ['node-configs:create', 'users:read', 'nodes:read'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['name', 'permissions'],
    additionalProperties: false
} as const;

export const $RevokeApiTokenData = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 30,
            example: 'CI pipeline',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=30'
            }
        }
    },
    required: ['id', 'name'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $RevokeApiTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/RevokeApiTokenData'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ApiToken = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 30,
            example: 'CI pipeline',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=30'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        permissions: {
            type: 'array',
            items: {
                type: 'string'
            },
            description: 'Permissions granted to this API token',
            example: ['node-configs:create', 'users:read', 'nodes:read'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revokedBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateRevoked: {
            type: 'string',
            format: 'date-time'
        }
    },
    required: ['id', 'name', 'tenantId', 'permissions', 'createdBy', 'dateCreated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ApiTokenFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        revoked: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ApiTokenSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-dateCreated', '+dateCreated']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -dateCreated +dateCreated'
    },
    additionalProperties: false
} as const;

export const $PaginatedApiTokensResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/ApiTokenFilters'
        },
        sort: {
            '$ref': '#/components/schemas/ApiTokenSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedApiTokensResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ApiToken'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedApiTokensResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ApiTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ApiToken'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $Permission = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'tags:create',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        resource: {
            type: 'string',
            example: 'tags',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        action: {
            type: 'string',
            example: 'create',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        description: {
            type: 'string',
            example: 'Create new tags',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['name', 'resource', 'action', 'description'],
    additionalProperties: false
} as const;

export const $PermissionsListResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Permission'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $Tenant = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            example: 'OrionTechs LLC',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        identityProviderID: {
            type: 'string',
            pattern: '^(saml|oidc)\\.[a-z0-9_-]+$',
            example: 'saml.oriontechs',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        domain: {
            type: 'string',
            pattern: '^[a-z0-9-]+(\\.[a-z0-9-]+)*$',
            example: 'oriontechs.co',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        development: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configAccessRestricted: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateHidden: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        slug: {
            type: 'string',
            pattern: '^[\\w\\d_-]+$',
            example: 'orion-techs-llc'
        }
    },
    required: ['id', 'name', 'identityProviderID', 'domain', 'development', 'configAccessRestricted', 'dateHidden'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'OrionTechs LLC'
        },
        isHidden: {
            type: 'boolean',
            example: true
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedTenantsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/TenantFilters'
        },
        sort: {
            '$ref': '#/components/schemas/TenantSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedTenantsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Tenant'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedTenantsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Tenant'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateTenant = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 3,
            maxLength: 100,
            example: 'OrionTechs LLC',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=3,max=100'
            }
        },
        identityProviderID: {
            type: 'string',
            minLength: 3,
            maxLength: 100,
            pattern: '^(saml|oidc)\\.[a-z0-9_-]+$',
            example: 'saml.oriontechs',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=3,max=100'
            }
        },
        domain: {
            type: 'string',
            minLength: 3,
            maxLength: 100,
            pattern: '^[a-z0-9-]+(\\.[a-z0-9-]+)*$',
            example: 'oriontechs.co',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=3,max=100'
            }
        },
        development: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configAccessRestricted: {
            type: 'boolean',
            example: false
        },
        slug: {
            type: 'string',
            minLength: 3,
            maxLength: 24,
            pattern: '^[\\w\\d_-]+$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=3,max=24'
            }
        }
    },
    required: ['name', 'identityProviderID', 'domain', 'development', 'slug'],
    additionalProperties: false
} as const;

export const $PatchTenant = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'OrionTechs LLC'
        },
        identityProviderID: {
            type: 'string',
            pattern: '^(saml|oidc)\\.[a-z0-9_-]+$',
            example: 'saml.oriontechs'
        },
        domain: {
            type: 'string',
            pattern: '^[a-z0-9-]+(\\.[a-z0-9-]+)*$',
            example: 'oriontechs.co'
        },
        configAccessRestricted: {
            type: 'boolean',
            example: false
        },
        hidden: {
            type: 'boolean',
            example: true
        },
        slug: {
            type: 'string',
            minLength: 3,
            maxLength: 24,
            pattern: '^[\\w\\d_-]+$',
            example: 'orion-techs-llc',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=3,max=24'
            }
        }
    },
    additionalProperties: false
} as const;

export const $SystemInfoSchema = {
    type: 'object',
    properties: {
        mgmtPlaneRelease: {
            type: 'string',
            example: 'v0.1.0-rc6',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['mgmtPlaneRelease'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $SystemInfoResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/SystemInfoSchema'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $NodeOperatingSystem = {
    type: 'string',
    enum: ['windows', 'linux', 'macos', 'not_applicable'],
    example: 'windows',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=windows linux macos not_applicable'
    }
} as const;

export const $JobStatus = {
    type: 'string',
    enum: ['running', 'success', 'warning', 'error', 'timeout'],
    example: 'success',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=running success warning error timeout'
    }
} as const;

export const $Job = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                tenantID: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                },
                badgeColor: {
                    type: 'string',
                    example: '#cecdcc'
                },
                childrenCount: {
                    type: 'integer',
                    minimum: 0,
                    description: 'Number of child subtenants',
                    example: 0
                },
                subtenantLevel: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 4,
                    description: 'The level of the subtenant in the hierarchy (0-4)',
                    example: 0
                }
            },
            required: ['id', 'tenantID', 'name', 'childrenCount', 'subtenantLevel']
        },
        name: {
            type: 'string',
            example: 'Configure 8 nodes-v0.0.12_dev, apac, sales',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        targetConfig: {
            type: 'object',
            properties: {
                configRevision: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        revisionNumber: {
                            type: 'integer'
                        },
                        configSchema: {
                            type: 'string',
                            example: 'v1.0.0'
                        },
                        filename: {
                            type: 'string',
                            example: 'public-api-mimic.cue'
                        },
                        description: {
                            type: 'string'
                        },
                        createdBy: {
                            '$ref': '#/components/schemas/UserInfo'
                        }
                    },
                    required: ['id', 'revisionNumber', 'configSchema', 'filename', 'description', 'createdBy']
                },
                nodeConfig: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        name: {
                            type: 'string'
                        },
                        latestRevisionNumber: {
                            type: 'integer'
                        },
                        operatingSystem: {
                            '$ref': '#/components/schemas/NodeOperatingSystem'
                        }
                    },
                    required: ['id', 'name', 'latestRevisionNumber', 'operatingSystem']
                }
            },
            required: ['configRevision', 'nodeConfig'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        status: {
            '$ref': '#/components/schemas/JobStatus'
        },
        nodeStatus: {
            type: 'object',
            properties: {
                running: {
                    type: 'integer',
                    example: 4
                },
                success: {
                    type: 'integer',
                    example: 3
                },
                warning: {
                    type: 'integer',
                    example: 2
                },
                error: {
                    type: 'integer',
                    example: 1
                },
                timeout: {
                    type: 'integer',
                    example: 3
                }
            },
            required: ['running', 'success', 'warning', 'error', 'timeout'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCompleted: {
            type: 'string',
            format: 'date-time'
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        notificationDismissed: {
            type: 'boolean',
            example: false
        }
    },
    required: ['id', 'tenantId', 'name', 'targetConfig', 'status', 'nodeStatus', 'dateCreated', 'createdBy'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $UuidOrNull = {
    anyOf: [
        {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        {
            type: 'string',
            enum: ['null']
        }
    ],
    description: 'Either a valid UUID or the string "null"',
    example: '550e8400-e29b-41d4-a716-446655440000',
    additionalProperties: false
} as const;

export const $JobFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        targetConfig: {
            type: 'string'
        },
        operatingSystem: {
            type: 'string',
            example: 'linux,windows'
        },
        notificationDismissed: {
            type: 'boolean'
        },
        nodeConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        status: {
            type: 'string',
            example: 'error,warning,timeout'
        },
        subtenantId: {
            '$ref': '#/components/schemas/UuidOrNull'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $JobSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-targetConfig', '+targetConfig', '-jobNumber', '+jobNumber', '-dateCreated', '+dateCreated', '-creatorName', '+creatorName']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -targetConfig +targetConfig -jobNumber +jobNumber -dateCreated +dateCreated -creatorName +creatorName'
    },
    additionalProperties: false
} as const;

export const $PaginatedJobsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/JobFilters'
        },
        sort: {
            '$ref': '#/components/schemas/JobSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedJobsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Job'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedJobsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $JobResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Job'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $JobNode = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        hostname: {
            type: 'string',
            example: 'apnyc-dc-001',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeVersion: {
            type: 'string',
            example: '1.0.0'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        status: {
            '$ref': '#/components/schemas/JobStatus'
        },
        statusDescription: {
            type: 'string',
            example: 'Node timed out'
        },
        dateCompleted: {
            type: 'string',
            format: 'date-time'
        },
        warnings: {
            nullable: true,
            example: [
                {
                    message: 'Warning message'
                },
                'Simple warning string'
            ]
        },
        errors: {
            nullable: true,
            example: [
                {
                    message: 'Error message'
                },
                'Simple error string'
            ]
        }
    },
    required: ['id', 'nodeId', 'hostname', 'operatingSystem', 'status'],
    additionalProperties: false
} as const;

export const $JobNodeFilters = {
    type: 'object',
    properties: {},
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $JobNodeSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-id', '+id', '-hostname', '+hostname', '-nodeVersion', '+nodeVersion', '-operatingSystem', '+operatingSystem', '-status', '+status']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-id +id -hostname +hostname -nodeVersion +nodeVersion -operatingSystem +operatingSystem -status +status'
    },
    additionalProperties: false
} as const;

export const $PaginatedJobNodesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/JobNodeFilters'
        },
        sort: {
            '$ref': '#/components/schemas/JobNodeSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedJobNodesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/JobNode'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedJobNodesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $JobNotificationsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                totalRunning: {
                    type: 'integer',
                    example: 3
                },
                totalWarnings: {
                    type: 'integer',
                    example: 5
                },
                totalErrors: {
                    type: 'integer',
                    example: 2
                },
                totalTimeouts: {
                    type: 'integer',
                    example: 1
                }
            },
            required: ['totalRunning', 'totalWarnings', 'totalErrors', 'totalTimeouts'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $UpdateJob = {
    type: 'object',
    properties: {
        notificationDismissed: {
            type: 'boolean',
            example: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['notificationDismissed'],
    additionalProperties: false
} as const;

export const $DismissJobNotificationsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                totalDismissed: {
                    type: 'integer',
                    example: 5
                }
            },
            required: ['totalDismissed'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $JobNotificationType = {
    type: 'string',
    enum: ['warning', 'error', 'timeout', 'running'],
    example: 'warning',
    additionalProperties: false
} as const;

export const $NodeConfigMode = {
    type: 'string',
    nullable: true,
    enum: ['standard', 'maintenance', 'audit'],
    example: 'standard',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=standard maintenance audit'
    }
} as const;

export const $ConnectivityState = {
    type: 'string',
    enum: ['connected', 'disconnected', 'degraded'],
    example: 'connected',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=connected disconnected degraded'
    }
} as const;

export const $HeartbeatConnectivityState = {
    type: 'string',
    enum: ['online', 'offline'],
    example: 'online',
    additionalProperties: false
} as const;

export const $NodeHeartbeatStates = {
    type: 'object',
    properties: {
        config: {
            type: 'object',
            properties: {
                state: {
                    '$ref': '#/components/schemas/HeartbeatConnectivityState'
                },
                stateTime: {
                    type: 'string',
                    format: 'date-time'
                }
            },
            required: ['state', 'stateTime'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        credential: {
            type: 'object',
            properties: {
                state: {
                    '$ref': '#/components/schemas/HeartbeatConnectivityState'
                },
                stateTime: {
                    type: 'string',
                    format: 'date-time'
                }
            },
            required: ['state', 'stateTime'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['config', 'credential'],
    additionalProperties: false
} as const;

export const $OperationalState = {
    type: 'string',
    enum: ['active', 'idle'],
    example: 'active',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=active idle'
    }
} as const;

export const $ConfigStatus = {
    type: 'string',
    enum: ['pending', 'applied', 'rejected'],
    example: 'pending',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=pending applied rejected'
    }
} as const;

export const $NodeArchitecture = {
    type: 'string',
    enum: ['amd64', 'arm64', 'x86_64', 'x64', 'x86'],
    example: 'amd64',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=amd64 arm64 x86_64 x64 x86'
    }
} as const;

export const $HostVolume = {
    type: 'object',
    properties: {
        correlation_id: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        volume_name: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        volume_id: {
            type: 'integer'
        },
        driver_id: {
            type: 'integer'
        },
        mount_flags: {
            type: 'integer'
        },
        device_type: {
            type: 'integer'
        },
        filesystem_type: {
            type: 'integer'
        },
        serial_number: {
            type: 'integer'
        },
        content_type: {
            type: 'integer'
        },
        drive_letter: {
            type: 'string'
        }
    },
    required: ['correlation_id', 'volume_name'],
    additionalProperties: false
} as const;

export const $SystemProfile = {
    type: 'object',
    properties: {
        'os.type': {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        'os.version': {
            type: 'string',
            example: '10.0.20348',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        'os.name': {
            type: 'string',
            example: 'Microsoft Windows Server 2022',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        'host.ip': {
            type: 'string',
            example: '10.0.0.1',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        'host.name': {
            type: 'string',
            example: 'apnyc-dc-001',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        'host.arch': {
            '$ref': '#/components/schemas/NodeArchitecture'
        },
        'host.cpu.family': {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'number'
                }
            ]
        },
        'host.cpu.model.name': {
            type: 'string'
        },
        'host.mac': {
            type: 'string'
        },
        'host.volumes': {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/HostVolume'
            }
        },
        'host.windows_domain': {
            type: 'string'
        },
        'host.windows_workgroup': {
            type: 'string'
        },
        'node.modules': {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        'os.build.id': {
            type: 'string'
        },
        'os.description': {
            type: 'string'
        },
        'release.build.time': {
            type: 'string'
        },
        'release.commit': {
            type: 'string'
        },
        'release.id': {
            type: 'string'
        },
        'release.package_type': {
            type: 'string'
        },
        'release.version': {
            type: 'string'
        }
    },
    required: ['os.type', 'os.version', 'os.name', 'host.ip', 'host.name'],
    additionalProperties: false
} as const;

export const $NodeCredentialTimestamps = {
    type: 'object',
    properties: {
        lastRotation: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        notBefore: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        notAfter: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['lastRotation', 'notBefore', 'notAfter'],
    additionalProperties: false
} as const;

export const $ActiveDirectoryProperties = {
    nullable: true,
    additionalProperties: false
} as const;

export const $ActiveDirectoryProfile = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            enum: ['active_directory'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=active_directory'
            }
        },
        properties: {
            '$ref': '#/components/schemas/ActiveDirectoryProperties'
        }
    },
    required: ['id', 'dateCreated', 'dateUpdated', 'name'],
    additionalProperties: false
} as const;

export const $ApplicationProfile = {
    oneOf: [
        {
            '$ref': '#/components/schemas/ActiveDirectoryProfile'
        }
    ],
    discriminator: {
        propertyName: 'name',
        mapping: {
            active_directory: '#/components/schemas/ActiveDirectoryProfile'
        }
    },
    additionalProperties: false
} as const;

export const $Node = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                tenantID: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                },
                badgeColor: {
                    type: 'string',
                    example: '#cecdcc'
                },
                description: {
                    type: 'string',
                    nullable: true,
                    example: 'Sales team subtenant'
                },
                childrenCount: {
                    type: 'integer',
                    minimum: 0,
                    description: 'Number of child subtenants',
                    example: 0
                },
                subtenantLevel: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 4,
                    description: 'The level of the subtenant in the hierarchy (0-4)',
                    example: 0
                }
            },
            required: ['id', 'tenantID', 'name', 'description', 'childrenCount', 'subtenantLevel']
        },
        name: {
            type: 'string',
            example: 'Sales App Server',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        hostname: {
            type: 'string',
            example: 'apnyc-dc-001',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        isOperating: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        hasRunningJob: {
            type: 'boolean'
        },
        appliedNodeConfigMode: {
            '$ref': '#/components/schemas/NodeConfigMode'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        connectivityState: {
            '$ref': '#/components/schemas/ConnectivityState'
        },
        heartbeatStates: {
            '$ref': '#/components/schemas/NodeHeartbeatStates'
        },
        lastSeen: {
            type: 'string',
            format: 'date-time'
        },
        dateArchived: {
            type: 'string',
            format: 'date-time'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 1,
                maxLength: 20,
                example: 'staging'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeVersion: {
            type: 'string',
            example: '1.0.0'
        },
        appliedRevisionState: {
            type: 'object',
            properties: {
                operationalState: {
                    '$ref': '#/components/schemas/OperationalState'
                },
                status: {
                    '$ref': '#/components/schemas/ConfigStatus'
                },
                statusDate: {
                    type: 'string',
                    format: 'date-time'
                },
                instructionSetId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                configRevision: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        revisionNumber: {
                            type: 'integer'
                        },
                        configSchema: {
                            type: 'string',
                            example: 'v1.0.0'
                        },
                        filename: {
                            type: 'string',
                            example: 'public-api-mimic.cue'
                        },
                        description: {
                            type: 'string'
                        }
                    },
                    required: ['id', 'revisionNumber', 'configSchema', 'filename', 'description']
                },
                nodeConfig: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        name: {
                            type: 'string'
                        },
                        latestRevisionNumber: {
                            type: 'integer'
                        },
                        operatingSystem: {
                            '$ref': '#/components/schemas/NodeOperatingSystem'
                        },
                        dateArchived: {
                            type: 'string',
                            nullable: true,
                            format: 'date-time'
                        },
                        mode: {
                            '$ref': '#/components/schemas/NodeConfigMode'
                        }
                    },
                    required: ['id', 'name', 'latestRevisionNumber', 'operatingSystem', 'dateArchived', 'mode']
                },
                assignedBy: {
                    '$ref': '#/components/schemas/UserInfo'
                }
            },
            required: ['operationalState']
        },
        requestedRevisionState: {
            type: 'object',
            properties: {
                operationalState: {
                    '$ref': '#/components/schemas/OperationalState'
                },
                status: {
                    '$ref': '#/components/schemas/ConfigStatus'
                },
                statusDate: {
                    type: 'string',
                    format: 'date-time'
                },
                instructionSetId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                configRevision: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        revisionNumber: {
                            type: 'integer'
                        },
                        configSchema: {
                            type: 'string',
                            example: 'v1.0.0'
                        },
                        filename: {
                            type: 'string',
                            example: 'public-api-mimic.cue'
                        },
                        description: {
                            type: 'string'
                        }
                    },
                    required: ['id', 'revisionNumber', 'configSchema', 'filename', 'description']
                },
                nodeConfig: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        name: {
                            type: 'string'
                        },
                        latestRevisionNumber: {
                            type: 'integer'
                        },
                        operatingSystem: {
                            '$ref': '#/components/schemas/NodeOperatingSystem'
                        },
                        dateArchived: {
                            type: 'string',
                            nullable: true,
                            format: 'date-time'
                        },
                        mode: {
                            '$ref': '#/components/schemas/NodeConfigMode'
                        }
                    },
                    required: ['id', 'name', 'latestRevisionNumber', 'operatingSystem', 'dateArchived', 'mode']
                },
                assignedBy: {
                    '$ref': '#/components/schemas/UserInfo'
                }
            },
            required: ['operationalState', 'status', 'statusDate'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        previousRevisionState: {
            type: 'object',
            properties: {
                operationalState: {
                    '$ref': '#/components/schemas/OperationalState'
                },
                status: {
                    '$ref': '#/components/schemas/ConfigStatus'
                },
                statusDate: {
                    type: 'string',
                    format: 'date-time'
                },
                instructionSetId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                configRevision: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        revisionNumber: {
                            type: 'integer'
                        },
                        configSchema: {
                            type: 'string',
                            example: 'v1.0.0'
                        },
                        filename: {
                            type: 'string',
                            example: 'public-api-mimic.cue'
                        },
                        description: {
                            type: 'string'
                        }
                    },
                    required: ['id', 'revisionNumber', 'configSchema', 'filename', 'description']
                },
                nodeConfig: {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string',
                            format: 'uuid',
                            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                        },
                        name: {
                            type: 'string'
                        },
                        latestRevisionNumber: {
                            type: 'integer'
                        },
                        operatingSystem: {
                            '$ref': '#/components/schemas/NodeOperatingSystem'
                        },
                        dateArchived: {
                            type: 'string',
                            nullable: true,
                            format: 'date-time'
                        },
                        mode: {
                            '$ref': '#/components/schemas/NodeConfigMode'
                        }
                    },
                    required: ['id', 'name', 'latestRevisionNumber', 'operatingSystem', 'dateArchived', 'mode']
                },
                assignedBy: {
                    '$ref': '#/components/schemas/UserInfo'
                }
            },
            required: ['operationalState', 'status', 'statusDate']
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        description: {
            type: 'string',
            example: 'Node Description'
        },
        systemProfile: {
            '$ref': '#/components/schemas/SystemProfile'
        },
        credentialTimestamps: {
            '$ref': '#/components/schemas/NodeCredentialTimestamps'
        },
        lastBaseline: {
            type: 'string',
            format: 'date-time'
        },
        applicationProfiles: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ApplicationProfile'
            }
        },
        nodeGroup: {
            type: 'object',
            nullable: true,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string'
                },
                createdBy: {
                    '$ref': '#/components/schemas/UserInfo'
                },
                dateCreated: {
                    type: 'string',
                    format: 'date-time'
                },
                configRevisionId: {
                    type: 'string',
                    nullable: true,
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                dateUpdated: {
                    type: 'string',
                    format: 'date-time'
                },
                updatedBy: {
                    '$ref': '#/components/schemas/UserInfo'
                }
            },
            required: ['id', 'name', 'createdBy', 'dateCreated', 'configRevisionId', 'dateUpdated', 'updatedBy'],
            description: 'The node group this node belongs to, if any'
        }
    },
    required: ['id', 'tenantId', 'name', 'hostname', 'isOperating', 'operatingSystem', 'connectivityState', 'dateCreated', 'tags', 'requestedRevisionState', 'dateUpdated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeFilters = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            example: '1e311dda-6ee1-40ce-aeef-36c9eb19023d,cdd36888-2f10-4171-aca3-e281d0c575cf'
        },
        subtenantId: {
            '$ref': '#/components/schemas/UuidOrNull'
        },
        subtenantName: {
            type: 'string',
            example: 'Marketing Team'
        },
        hostname: {
            type: 'string',
            example: 'sales'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        name: {
            type: 'string',
            example: 'sales'
        },
        assignedBy: {
            type: 'string',
            example: '1e311dda-6ee1-40ce-aeef-36c9eb19023d,cdd36888-2f10-4171-aca3-e281d0c575cf'
        },
        tags: {
            type: 'string',
            example: 'sales,prod'
        },
        isArchived: {
            type: 'boolean',
            example: true
        },
        isOperating: {
            type: 'boolean',
            example: true
        },
        appliedNodeConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        hasBaseline: {
            type: 'boolean',
            example: true
        },
        nodeGroupId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'Filter nodes by node group membership'
        },
        hasNodeGroup: {
            type: 'boolean',
            description: 'Filter nodes by whether they belong to any node group',
            example: true
        }
    },
    example: {
        name: 'sales'
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-hostname', '+hostname', '-name', '+name', '-appliedOperationalState', '+appliedOperationalState', '-isOperating', '+isOperating', '-connectivityState', '+connectivityState', '-operatingSystem', '+operatingSystem', '-lastSeen', '+lastSeen', '-dateCreated', '+dateCreated', '-appliedConfiguration', '+appliedConfiguration', '-dateConfigRevisionApplied', '+dateConfigRevisionApplied', '-nodeVersion', '+nodeVersion', '-appliedNodeConfigMode', '+appliedNodeConfigMode']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-hostname +hostname -name +name -appliedOperationalState +appliedOperationalState -isOperating +isOperating -connectivityState +connectivityState -operatingSystem +operatingSystem -lastSeen +lastSeen -dateCreated +dateCreated -appliedConfiguration +appliedConfiguration -dateConfigRevisionApplied +dateConfigRevisionApplied -nodeVersion +nodeVersion -appliedNodeConfigMode +appliedNodeConfigMode'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Node'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Node'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $PatchNode = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Sales App Server'
        },
        description: {
            type: 'string',
            example: 'Node Description'
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        }
    },
    additionalProperties: false
} as const;

export const $OperationalStateChangeSchema = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationalState: {
            '$ref': '#/components/schemas/OperationalState'
        },
        status: {
            '$ref': '#/components/schemas/ConfigStatus'
        },
        jobId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'operationalState', 'status', 'jobId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $OperationalStateChangeResp = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/OperationalStateChangeSchema'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $RequestedOperationalState = {
    type: 'object',
    properties: {
        requestedOperationalState: {
            '$ref': '#/components/schemas/OperationalState'
        }
    },
    required: ['requestedOperationalState'],
    additionalProperties: false
} as const;

export const $BulkOperationalStateChangeResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            description: 'Success message',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message'],
    additionalProperties: false
} as const;

export const $BulkOperationalStateChangeErrorItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            description: 'Error message for this node',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'message'],
    additionalProperties: false
} as const;

export const $BulkOperationalStateChangeErrorResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            description: 'Summary error message',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkOperationalStateChangeErrorItem'
            },
            description: 'List of validation errors per node',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message', 'errors'],
    additionalProperties: false
} as const;

export const $BulkOperationalStateChangeNode = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        requestedOperationalState: {
            '$ref': '#/components/schemas/OperationalState'
        }
    },
    required: ['nodeId', 'requestedOperationalState'],
    additionalProperties: false
} as const;

export const $BulkOperationalStateChangeRequest = {
    type: 'object',
    properties: {
        nodes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkOperationalStateChangeNode'
            },
            minItems: 1,
            example: [
                {
                    nodeId: '550e8400-e29b-41d4-a716-446655440000',
                    requestedOperationalState: 'active'
                },
                {
                    nodeId: '550e8400-e29b-41d4-a716-446655440001',
                    requestedOperationalState: 'idle'
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodes'],
    additionalProperties: false
} as const;

export const $BulkArchiveResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            description: 'Success message',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message'],
    additionalProperties: false
} as const;

export const $BulkArchiveErrorItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            description: 'Error message for this node',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'message'],
    additionalProperties: false
} as const;

export const $BulkArchiveErrorResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            description: 'Summary error message',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkArchiveErrorItem'
            },
            description: 'List of validation errors per node',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message', 'errors'],
    additionalProperties: false
} as const;

export const $BulkArchiveNode = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId'],
    additionalProperties: false
} as const;

export const $BulkArchiveRequest = {
    type: 'object',
    properties: {
        nodes: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkArchiveNode'
            },
            minItems: 1,
            example: [
                {
                    nodeId: '550e8400-e29b-41d4-a716-446655440000'
                },
                {
                    nodeId: '550e8400-e29b-41d4-a716-446655440001'
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodes'],
    additionalProperties: false
} as const;

export const $UpdateBaselineResponse = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        jobId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'jobId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $UpdateBaselineResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/UpdateBaselineResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $UpdateBaselineRequest = {
    type: 'object',
    properties: {
        jobName: {
            type: 'string',
            example: 'job name'
        }
    },
    additionalProperties: false
} as const;

export const $EnableMaintenanceResponse = {
    type: 'object',
    properties: {
        maintenanceConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'The ID of the created or existing maintenance config',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['maintenanceConfigId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $EnableMaintenanceResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/EnableMaintenanceResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $BulkMaintenanceResultItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        maintenanceConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'maintenanceConfigId'],
    additionalProperties: false
} as const;

export const $BulkMaintenanceResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkMaintenanceResultItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $BulkMaintenanceErrorItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'message'],
    additionalProperties: false
} as const;

export const $BulkMaintenanceErrorResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkMaintenanceErrorItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message', 'errors'],
    additionalProperties: false
} as const;

export const $BulkMaintenanceRequest = {
    type: 'object',
    properties: {
        nodes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    nodeId: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                        example: '550e8400-e29b-41d4-a716-446655440000'
                    }
                },
                required: ['nodeId']
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodes'],
    additionalProperties: false
} as const;

export const $NodeTag = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tagId: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'tagId', 'createdBy', 'dateCreated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTagResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/NodeTag'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $NodeConfigHistoryEntry = {
    type: 'object',
    properties: {
        instructionSetId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        status: {
            '$ref': '#/components/schemas/ConfigStatus'
        },
        operationalState: {
            '$ref': '#/components/schemas/OperationalState'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevision: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                revisionNumber: {
                    type: 'integer'
                },
                configSchema: {
                    type: 'string',
                    example: 'v1.0.0'
                },
                filename: {
                    type: 'string',
                    example: 'public-api-mimic.cue'
                },
                description: {
                    type: 'string'
                }
            },
            required: ['id', 'revisionNumber', 'configSchema', 'filename', 'description'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeConfig: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string'
                },
                operatingSystem: {
                    '$ref': '#/components/schemas/NodeOperatingSystem'
                },
                mode: {
                    '$ref': '#/components/schemas/NodeConfigMode'
                }
            },
            required: ['id', 'name', 'operatingSystem', 'mode'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        assignedBy: {
            '$ref': '#/components/schemas/UserInfo'
        }
    },
    required: ['instructionSetId', 'status', 'operationalState', 'dateCreated', 'dateUpdated', 'configRevision', 'nodeConfig'],
    additionalProperties: false
} as const;

export const $NodeConfigHistoryFilters = {
    type: 'object',
    properties: {
        status: {
            '$ref': '#/components/schemas/ConfigStatus'
        },
        operationalState: {
            '$ref': '#/components/schemas/OperationalState'
        },
        mode: {
            '$ref': '#/components/schemas/NodeConfigMode'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeConfigHistorySortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-dateCreated', '+dateCreated', '-dateUpdated', '+dateUpdated']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-dateCreated +dateCreated -dateUpdated +dateUpdated'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeConfigHistoryResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeConfigHistoryFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeConfigHistorySortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeConfigHistoryResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeConfigHistoryEntry'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeConfigHistoryResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $BulkAssignResultItem = {
    type: 'object',
    properties: {
        jobId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevisionNumber: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                example: '550e8400-e29b-41d4-a716-446655440000'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['jobId', 'configId', 'configRevisionNumber', 'nodeIds'],
    additionalProperties: false
} as const;

export const $BulkAssignResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkAssignResultItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $BulkAssignErrorItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000'
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        revisionNumber: {
            type: 'integer'
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message'],
    additionalProperties: false
} as const;

export const $BulkAssignErrorResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkAssignErrorItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message', 'errors'],
    additionalProperties: false
} as const;

export const $BulkAssignAssignment = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revisionNumber: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'configId', 'revisionNumber'],
    additionalProperties: false
} as const;

export const $BulkAssignRequest = {
    type: 'object',
    properties: {
        assignments: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BulkAssignAssignment'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['assignments'],
    additionalProperties: false
} as const;

export const $PreviousConfigResultItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revisionNumber: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'configId', 'revisionNumber'],
    additionalProperties: false
} as const;

export const $PreviousConfigResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PreviousConfigResultItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $PreviousConfigErrorItem = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'message'],
    additionalProperties: false
} as const;

export const $PreviousConfigErrorResponse = {
    type: 'object',
    properties: {
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/PreviousConfigErrorItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['message', 'errors'],
    additionalProperties: false
} as const;

export const $PreviousConfigRequest = {
    type: 'object',
    properties: {
        nodes: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    nodeId: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                        example: '550e8400-e29b-41d4-a716-446655440000'
                    }
                },
                required: ['nodeId']
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodes'],
    additionalProperties: false
} as const;

export const $User = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        displayName: {
            type: 'string',
            example: 'John Wilkinson',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstName: {
            type: 'string',
            example: 'John',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastName: {
            type: 'string',
            example: 'Wilkinson',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john.wilkinson@mimic.com',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantName: {
            type: 'string',
            example: 'Acme Corp',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        role: {
            type: 'string',
            enum: ['viewer', 'editor', 'admin', 'superadmin'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=viewer editor admin superadmin'
            }
        },
        subtenantOnly: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        defaultSubtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    'x-go-name': 'ID',
                    example: '550e8400-e29b-41d4-a716-446655440000'
                },
                name: {
                    type: 'string',
                    example: 'Acme Corp - Subtenant 1'
                }
            },
            required: ['id', 'name']
        },
        removed: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        updatedBy: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'displayName', 'firstName', 'lastName', 'email', 'tenantID', 'tenantName', 'role', 'subtenantOnly', 'removed', 'createdBy', 'dateCreated', 'updatedBy', 'dateUpdated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $UserFilters = {
    type: 'object',
    properties: {
        removed: {
            type: 'boolean',
            example: true
        }
    },
    example: {
        removed: true
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $UserSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-displayName', '+displayName']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-displayName +displayName'
    },
    additionalProperties: false
} as const;

export const $PaginatedUsersResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/UserFilters'
        },
        sort: {
            '$ref': '#/components/schemas/UserSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedUsersResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/User'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedUsersResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $UserResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/User'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateUser = {
    type: 'object',
    properties: {
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            example: 'John',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=100'
            }
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            example: 'Wilkinson',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=100'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john.wilkinson@mimic.com',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        role: {
            type: 'string',
            enum: ['viewer', 'editor', 'admin'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=viewer editor admin'
            }
        },
        subtenantOnly: {
            type: 'boolean',
            example: false
        }
    },
    required: ['firstName', 'lastName', 'email', 'role'],
    additionalProperties: false
} as const;

export const $PatchUser = {
    type: 'object',
    properties: {
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            example: 'John',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1,max=100'
            }
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            example: 'Wilkinson',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1,max=100'
            }
        },
        role: {
            type: 'string',
            enum: ['viewer', 'editor', 'admin', 'superadmin'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,oneof=viewer editor admin superadmin'
            }
        },
        email: {
            type: 'string',
            format: 'email',
            example: 'john.wilkinson@mimic.com'
        },
        subtenantOnly: {
            type: 'boolean',
            example: false
        },
        removed: {
            type: 'boolean',
            example: false
        }
    },
    additionalProperties: false
} as const;

export const $UserSubtenant = {
    type: 'object',
    properties: {
        subtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                },
                subtenants: {
                    type: 'array',
                    nullable: true,
                    items: {
                        type: 'object',
                        properties: {
                            subtenant: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        format: 'uuid',
                                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                                    },
                                    name: {
                                        type: 'string',
                                        example: 'Sales App'
                                    }
                                },
                                required: ['id', 'name']
                            },
                            role: {
                                type: 'string',
                                enum: ['none', 'viewer', 'editor', 'admin'],
                                example: 'viewer'
                            }
                        },
                        required: ['subtenant', 'role']
                    }
                }
            },
            required: ['id', 'name'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        role: {
            type: 'string',
            enum: ['none', 'viewer', 'editor', 'admin'],
            example: 'viewer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=none viewer editor admin'
            }
        }
    },
    required: ['subtenant', 'role'],
    additionalProperties: false
} as const;

export const $UserSubtenantFilterParams = {
    type: 'object',
    properties: {
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'subtenantID',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $UserSubtenantSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedUserSubtenantMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/UserSubtenantFilterParams'
        },
        sort: {
            '$ref': '#/components/schemas/UserSubtenantSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedUserSubtenant = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/UserSubtenant'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedUserSubtenantMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $PatchUserSubtenants = {
    type: 'object',
    properties: {
        subtenants: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    subtenantId: {
                        type: 'string',
                        format: 'uuid',
                        example: '550e8400-e29b-41d4-a716-446655440000'
                    },
                    role: {
                        type: 'string',
                        enum: ['inherit', 'none', 'viewer', 'editor', 'admin'],
                        example: 'viewer'
                    }
                },
                required: ['subtenantId', 'role']
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['subtenants'],
    additionalProperties: false
} as const;

export const $Tag = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            example: 'staging',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=20'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        useCount: {
            type: 'integer',
            minimum: 0,
            example: 10,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        createdBy: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        updatedBy: {
            type: 'string',
            format: 'uuid',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'name', 'tenantID', 'useCount', 'createdBy', 'dateCreated', 'updatedBy', 'dateUpdated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TagFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            example: 'sta',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1,max=20'
            }
        }
    },
    example: {
        name: 'sta'
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TagSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-useCount', '+useCount']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -useCount +useCount'
    },
    additionalProperties: false
} as const;

export const $PaginatedTagsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/TagFilters'
        },
        sort: {
            '$ref': '#/components/schemas/TagSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedTagsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Tag'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedTagsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TagResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/Tag'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateTag = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            example: 'staging',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=20'
            }
        }
    },
    required: ['name'],
    additionalProperties: false
} as const;

export const $PatchTag = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            example: 'staging',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1,max=20'
            }
        }
    },
    additionalProperties: false
} as const;

export const $ConfigRevision = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revisionNumber: {
            type: 'integer',
            example: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        filename: {
            type: 'string',
            example: 'public-api-mimic.cue',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configSchema: {
            type: 'string',
            example: 'v1.0.0',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        source: {
            type: 'string',
            example: 'some cuelang code'
        },
        description: {
            type: 'string',
            example: 'Revision message goes here',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        nodeConfig: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'public-api-mimic'
                }
            },
            required: ['id', 'name']
        }
    },
    required: ['id', 'revisionNumber', 'filename', 'configSchema', 'description', 'createdBy', 'createdAt'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeConfig = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            example: 'public-api-mimic',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        notes: {
            type: 'string',
            example: 'Config for public apis'
        },
        os: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        subtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                tenantID: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                },
                badgeColor: {
                    type: 'string',
                    example: '#cecdcc'
                },
                description: {
                    type: 'string',
                    nullable: true,
                    example: 'Sales team subtenant'
                },
                childrenCount: {
                    type: 'integer',
                    minimum: 0,
                    description: 'Number of child subtenants',
                    example: 0
                },
                subtenantLevel: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 4,
                    description: 'The level of the subtenant in the hierarchy (0-4)',
                    example: 0
                }
            },
            required: ['id', 'tenantID', 'name', 'description', 'childrenCount', 'subtenantLevel']
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateArchived: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        updatedBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        latestConfigRevision: {
            '$ref': '#/components/schemas/ConfigRevision'
        },
        useCount: {
            type: 'integer',
            example: 5,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        outdatedUseCount: {
            type: 'integer',
            example: 2,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        latestRevisionNumber: {
            type: 'integer',
            example: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        default: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'name', 'os', 'dateCreated', 'dateUpdated', 'dateArchived', 'createdBy', 'updatedBy', 'latestConfigRevision', 'useCount', 'outdatedUseCount', 'latestRevisionNumber', 'default'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeConfigResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/NodeConfig'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ConfigRevisionResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ConfigRevision'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ConfigAssignmentResponse = {
    type: 'object',
    properties: {
        jobId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'The BigBird job ID for both immediate and scheduled assignments.',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevisionNumber: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        scheduledAt: {
            type: 'string',
            nullable: true,
            description: 'The ISO 8601 datetime when the assignment is scheduled to run. Null for immediate assignment.',
            example: '2024-12-31T23:59:59Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['jobId', 'configId', 'configRevisionNumber', 'nodeIds', 'scheduledAt'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ConfigAssignmentResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ConfigAssignmentResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ConfigAssignmentRequest = {
    type: 'object',
    properties: {
        jobName: {
            type: 'string',
            example: 'job name'
        },
        configRevisionNumber: {
            type: 'integer'
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        skipOsValidation: {
            type: 'boolean',
            description: 'Skip OS validation when assigning config to nodes. Use with caution - allows assigning configs to nodes with different OS types.',
            example: false
        },
        assignAt: {
            type: 'string',
            description: 'ISO 8601 datetime for when to apply the config. If provided, the assignment is scheduled for that time instead of being applied immediately.',
            example: '2024-12-31T23:59:59Z'
        }
    },
    required: ['nodeIds'],
    additionalProperties: false
} as const;

export const $PatchNodeConfig = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        notes: {
            type: 'string'
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        }
    },
    additionalProperties: false
} as const;

export const $NodeConfigFilters = {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        os: {
            type: 'string',
            example: 'windows,linux'
        },
        subtenantId: {
            '$ref': '#/components/schemas/UuidOrNull'
        },
        isArchived: {
            type: 'boolean',
            example: true
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeConfigSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-dateUpdated', '+dateUpdated', '-os', '+os', '-useCount', '+useCount']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -dateUpdated +dateUpdated -os +os -useCount +useCount'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeConfigsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeConfigFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeConfigSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeConfigsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeConfig'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeConfigsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ConfigRevisionFilters = {
    type: 'object',
    properties: {
        description: {
            type: 'string'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ConfigRevisionsSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedConfigRevisionResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/ConfigRevisionFilters'
        },
        sort: {
            '$ref': '#/components/schemas/ConfigRevisionsSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedConfigRevisionResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ConfigRevision'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedConfigRevisionResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $CreateAuditConfigResponse = {
    type: 'object',
    properties: {
        auditConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'The ID of the created or existing audit config',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['auditConfigId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CreateAuditConfigResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CreateAuditConfigResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateAuditConfigRequest = {
    type: 'object',
    properties: {
        revisionNumber: {
            type: 'integer',
            description: 'The revision number of the source config to use',
            example: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['revisionNumber'],
    additionalProperties: false
} as const;

export const $CancelScheduledAssignmentResponse = {
    type: 'object',
    properties: {
        status: {
            type: 'string',
            description: 'The status of the cancellation',
            example: 'cancelled',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['status'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CancelScheduledAssignmentResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CancelScheduledAssignmentResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $NodeLifecycleEvent = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventType: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventTimestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        msg: {
            type: 'string'
        },
        configRevision: {
            type: 'object',
            properties: {
                nodeConfigID: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    example: 'ee0293bd-af0f-4cc6-9bf8-9fe6de3d3bed'
                },
                nodeConfigName: {
                    type: 'string'
                },
                revisionNumber: {
                    type: 'number'
                }
            },
            required: ['nodeConfigID', 'nodeConfigName', 'revisionNumber']
        }
    },
    required: ['id', 'nodeID', 'tenantID', 'eventType', 'eventTimestamp'],
    additionalProperties: false
} as const;

export const $LifecycleFilters = {
    type: 'object',
    properties: {
        type: {
            type: 'string'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $LifecycleSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeLifecycleEventsMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/LifecycleFilters'
        },
        sort: {
            '$ref': '#/components/schemas/LifecycleSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeLifecycleEvents = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeLifecycleEvent'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeLifecycleEventsMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeActivityTelemetry = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['HALLMARK', 'DEFLECTION', 'SIGNAL'],
            example: 'HALLMARK',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=HALLMARK DEFLECTION SIGNAL'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeName: {
            type: 'string',
            example: 'Sales App Server',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeHostname: {
            type: 'string',
            example: 'apnyc-dc-001',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeConnectivity: {
            '$ref': '#/components/schemas/ConnectivityState'
        },
        occurrences: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['type', 'tenantId', 'nodeId', 'nodeName', 'nodeHostname', 'nodeConnectivity', 'occurrences', 'firstSeen', 'lastSeen'],
    additionalProperties: false
} as const;

export const $ActivityTelemetryFilters = {
    type: 'object',
    properties: {
        subtenantId: {
            '$ref': '#/components/schemas/UuidOrNull'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeActivityTelemetrySortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedActivityTelemetryMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/ActivityTelemetryFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeActivityTelemetrySortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedActivityTelemetry = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeActivityTelemetry'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedActivityTelemetryMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeTelemetry = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            enum: ['HALLMARK', 'DEFLECTION', 'SIGNAL'],
            example: 'HALLMARK',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=HALLMARK DEFLECTION SIGNAL'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mimicId: {
            type: 'string',
            example: '0007',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mimicDescription: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        occurrences: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['type', 'tenantId', 'nodeId', 'mimicId', 'mimicDescription', 'occurrences', 'firstSeen', 'lastSeen'],
    additionalProperties: false
} as const;

export const $NodeTelemetryFilters = {
    type: 'object',
    properties: {
        mimicId: {
            type: 'string'
        },
        mimicDescription: {
            type: 'string'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetrySortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeTelemetryMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeTelemetryFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeTelemetrySortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeTelemetry = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetry'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeTelemetryMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeTelemetryEvent = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        type: {
            type: 'string',
            enum: ['HALLMARK', 'DEFLECTION', 'SIGNAL'],
            example: 'HALLMARK',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=HALLMARK DEFLECTION SIGNAL'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mimicId: {
            type: 'string',
            example: '0007',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mimicDescription: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        payload: {
            type: 'object',
            properties: {},
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        startTime: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'type', 'tenantId', 'nodeId', 'mimicId', 'mimicDescription', 'payload', 'startTime'],
    additionalProperties: false
} as const;

export const $NodeTelemetryEventsFilters = {
    type: 'object',
    properties: {},
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeTelemetryEventsMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeTelemetryEventsFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeTelemetrySortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeTelemetryEvents = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetryEvent'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeTelemetryEventsMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ClearTelemetryResponse = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        clearEventId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'clearEventID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventTime: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        reason: {
            type: 'string',
            example: 'Clearing hallmarks for testing',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        userId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'userID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'clearEventId', 'eventTime', 'reason', 'userId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ClearTelemetryResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ClearTelemetryResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ClearTelemetry = {
    oneOf: [
        {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['selected']
                },
                mimicIds: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                telemetryEventIds: {
                    type: 'array',
                    items: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    }
                },
                reason: {
                    type: 'string',
                    example: 'Clearing hallmarks for testing'
                }
            },
            required: ['type', 'mimicIds', 'telemetryEventIds', 'reason'],
            'x-go-type-name': 'ClearSelectedTelemetry'
        },
        {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['all']
                },
                reason: {
                    type: 'string',
                    example: 'Clearing hallmarks for testing'
                }
            },
            required: ['type', 'reason'],
            'x-go-type-name': 'ClearAllTelemetry'
        }
    ],
    additionalProperties: false
} as const;

export const $NodeTelemetryHistogramBucket = {
    type: 'object',
    properties: {
        time: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['time', 'operationName', 'count'],
    additionalProperties: false
} as const;

export const $NodeTelemetryHistogramMeta = {
    type: 'object',
    properties: {
        bucketLabel: {
            type: 'string',
            enum: ['1m', '5m', '15m', '1h', '4h', '1d'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=1m 5m 15m 1h 4h 1d'
            }
        },
        bucketMs: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['bucketLabel', 'bucketMs', 'since', 'until'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetryHistogramResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetryHistogramBucket'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/NodeTelemetryHistogramMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeTelemetryGroupedRow = {
    type: 'object',
    properties: {
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventCount: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['operationName', 'eventCount', 'firstSeen', 'lastSeen'],
    additionalProperties: false
} as const;

export const $NodeTelemetryGroupedMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['hasMore', 'since', 'until'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetryGroupedResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetryGroupedRow'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/NodeTelemetryGroupedMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeTelemetrySummarySegment = {
    type: 'object',
    properties: {
        text: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mono: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['text', 'mono'],
    additionalProperties: false
} as const;

export const $NodeTelemetryStreamEvent = {
    type: 'object',
    properties: {
        eventId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventTimestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        processId: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        isAdEvent: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        summary: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetrySummarySegment'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        summaryIsFallback: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['eventId', 'eventTimestamp', 'operationName', 'processId', 'isAdEvent', 'summary', 'summaryIsFallback'],
    additionalProperties: false
} as const;

export const $NodeTelemetryStreamCursor = {
    type: 'object',
    nullable: true,
    properties: {
        timestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['timestamp', 'eventId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetryStreamMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nextCursor: {
            '$ref': '#/components/schemas/NodeTelemetryStreamCursor'
        }
    },
    required: ['hasMore', 'nextCursor'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetryStreamResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetryStreamEvent'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/NodeTelemetryStreamMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeTelemetryOperationName = {
    type: 'object',
    properties: {
        value: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['value', 'count'],
    additionalProperties: false
} as const;

export const $NodeTelemetryOperationNamesMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['hasMore'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeTelemetryOperationNamesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeTelemetryOperationName'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/NodeTelemetryOperationNamesMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeResourceUtilizationRow = {
    type: 'object',
    properties: {
        bucket: {
            type: 'string',
            format: 'date-time',
            description: 'Start of the minute window this row covers, in UTC. The bucket spans [bucket, bucket + 1 minute).',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        cpuUserPct: {
            type: 'number',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        memPct: {
            type: 'number',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        memBytes: {
            type: 'integer',
            description: 'Used host memory in bytes at the most recent sample within the bucket. int64 to avoid overflow on large hosts in clients that default integer to int32.',
            format: 'int64',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['bucket', 'cpuUserPct', 'memPct', 'memBytes'],
    additionalProperties: false
} as const;

export const $NodeResourceUtilizationMeta = {
    type: 'object',
    properties: {
        bucketLabel: {
            type: 'string',
            enum: ['minute'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=minute'
            }
        },
        bucketMs: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['bucketLabel', 'bucketMs', 'since', 'until'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeResourceUtilizationResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeResourceUtilizationRow'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/NodeResourceUtilizationMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryHistogramBucket = {
    type: 'object',
    properties: {
        time: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['time', 'operationName', 'count'],
    additionalProperties: false
} as const;

export const $TenantTelemetryHistogramMeta = {
    type: 'object',
    properties: {
        bucketLabel: {
            type: 'string',
            enum: ['1m', '5m', '15m', '1h', '4h', '1d'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=1m 5m 15m 1h 4h 1d'
            }
        },
        bucketMs: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['bucketLabel', 'bucketMs', 'since', 'until'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryHistogramResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryHistogramBucket'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryHistogramMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryGroupedRow = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventCount: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'operationName', 'eventCount', 'firstSeen', 'lastSeen'],
    additionalProperties: false
} as const;

export const $TenantTelemetryGroupedMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        groupBy: {
            type: 'string',
            enum: ['operation', 'node', 'node,operation'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=operation node node,operation'
            }
        }
    },
    required: ['hasMore', 'since', 'until', 'groupBy'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryGroupedResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryGroupedRow'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryGroupedMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetrySummarySegment = {
    type: 'object',
    properties: {
        text: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        mono: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['text', 'mono'],
    additionalProperties: false
} as const;

export const $TenantTelemetryStreamEvent = {
    type: 'object',
    properties: {
        eventId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventTimestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        processId: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        isAdEvent: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        summary: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetrySummarySegment'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        summaryIsFallback: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['eventId', 'eventTimestamp', 'operationName', 'nodeId', 'processId', 'isAdEvent', 'summary', 'summaryIsFallback'],
    additionalProperties: false
} as const;

export const $TenantTelemetryStreamCursor = {
    type: 'object',
    nullable: true,
    properties: {
        timestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['timestamp', 'eventId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryStreamMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nextCursor: {
            '$ref': '#/components/schemas/TenantTelemetryStreamCursor'
        }
    },
    required: ['hasMore', 'nextCursor'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryStreamResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryStreamEvent'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryStreamMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryOperationName = {
    type: 'object',
    properties: {
        value: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['value', 'count'],
    additionalProperties: false
} as const;

export const $TenantTelemetryOperationNamesMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['hasMore'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryOperationNamesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryOperationName'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryOperationNamesMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryNode = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'name', 'count'],
    additionalProperties: false
} as const;

export const $TenantTelemetryNodesMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['hasMore'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryNodesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryNode'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryNodesMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryBlobField = {
    type: 'object',
    properties: {
        field: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        count: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['field', 'count'],
    additionalProperties: false
} as const;

export const $TenantTelemetryBlobFieldsMeta = {
    type: 'object',
    properties: {
        sampleSize: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['sampleSize'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryBlobFieldsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantTelemetryBlobField'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TenantTelemetryBlobFieldsMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantTelemetryEvent = {
    type: 'object',
    properties: {
        eventId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventTimestamp: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        operationName: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        processId: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        isAdEvent: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        eventBlob: {
            type: 'object',
            additionalProperties: {
                nullable: true
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['eventId', 'eventTimestamp', 'operationName', 'nodeId', 'tenantId', 'processId', 'isAdEvent', 'eventBlob'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantTelemetryEventResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/TenantTelemetryEvent'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $NodePackageType = {
    type: 'string',
    enum: ['deb', 'rpm', 'msi', 'exe'],
    example: 'msi',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=deb rpm msi exe'
    }
} as const;

export const $BaseReleaseSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: 'C8524635-D25D-4215-8BCB-136C27A0C998',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        version: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            '$ref': '#/components/schemas/NodeArchitecture'
        },
        targetOs: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        packageType: {
            '$ref': '#/components/schemas/NodePackageType'
        },
        dateReleased: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'version', 'buildNumber', 'schemaVersion', 'architecture', 'targetOs', 'packageType', 'dateReleased', 'debug'],
    additionalProperties: false
} as const;

export const $ReleaseFilters = {
    type: 'object',
    properties: {
        version: {
            type: 'string'
        },
        architecture: {
            '$ref': '#/components/schemas/NodeArchitecture'
        },
        targetOs: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        packageType: {
            '$ref': '#/components/schemas/NodePackageType'
        },
        debug: {
            type: 'boolean'
        },
        schemaVersion: {
            type: 'string'
        },
        packageSha256: {
            type: 'string'
        },
        hasScoutMode: {
            type: 'boolean'
        },
        buildNumber: {
            type: 'string'
        },
        latestBuild: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ReleaseSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-version', '+version', '-architecture', '+architecture', '-targetOs', '+targetOs', '-packageType', '+packageType', '-debug', '+debug', '-dateReleased', '+dateReleased', '-buildNumber', '+buildNumber', '-schemaVersion', '+schemaVersion']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-version +version -architecture +architecture -targetOs +targetOs -packageType +packageType -debug +debug -dateReleased +dateReleased -buildNumber +buildNumber -schemaVersion +schemaVersion'
    },
    additionalProperties: false
} as const;

export const $PaginatedReleasesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/ReleaseFilters'
        },
        sort: {
            '$ref': '#/components/schemas/ReleaseSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedReleasesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/BaseReleaseSchema'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedReleasesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ReleaseResponse = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: 'C8524635-D25D-4215-8BCB-136C27A0C998',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        version: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            '$ref': '#/components/schemas/NodeArchitecture'
        },
        targetOs: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        packageType: {
            '$ref': '#/components/schemas/NodePackageType'
        },
        dateReleased: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        scoutModeConfig: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'version', 'buildNumber', 'schemaVersion', 'architecture', 'targetOs', 'packageType', 'dateReleased', 'debug', 'scoutModeConfig'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ReleaseResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $UpdateReleaseResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $PatchRelease = {
    type: 'object',
    properties: {
        scoutModeConfig: {
            type: 'string'
        }
    },
    additionalProperties: false
} as const;

export const $PublishReleaseResponse = {
    type: 'object',
    properties: {
        releaseId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                example: '550e8400-e29b-41d4-a716-446655440000'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['releaseId', 'tenantIds'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PublishReleaseResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/PublishReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $PublishRelease = {
    type: 'object',
    properties: {
        tenantIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                example: '550e8400-e29b-41d4-a716-446655440000'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tenantIds'],
    additionalProperties: false
} as const;

export const $RevokeReleaseResponse = {
    type: 'object',
    properties: {
        releaseId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                example: '550e8400-e29b-41d4-a716-446655440000'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['releaseId', 'tenantIds'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $RevokeReleaseResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/RevokeReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $RevokeRelease = {
    type: 'object',
    properties: {
        tenantIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                example: '550e8400-e29b-41d4-a716-446655440000'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tenantIds'],
    additionalProperties: false
} as const;

export const $TenantReleaseListItem = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        version: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            nullable: true,
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            type: 'string',
            nullable: true,
            description: 'Node architecture',
            example: 'amd64',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        targetOs: {
            type: 'string',
            nullable: true,
            description: 'Target operating system',
            example: 'linux',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageType: {
            type: 'string',
            nullable: true,
            description: 'Package type',
            example: 'deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateReleased: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        package: {
            type: 'string',
            nullable: true,
            example: 'node-v1.2.3-linux-amd64.deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSha256: {
            type: 'string',
            nullable: true,
            example: 'abc123...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSizeBytes: {
            type: 'integer',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'version', 'buildNumber', 'schemaVersion', 'architecture', 'targetOs', 'packageType', 'dateReleased', 'debug', 'package', 'packageSha256', 'packageSizeBytes'],
    additionalProperties: false
} as const;

export const $TenantReleaseFilters = {
    type: 'object',
    properties: {
        version: {
            type: 'string'
        },
        architecture: {
            '$ref': '#/components/schemas/NodeArchitecture'
        },
        targetOs: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        packageType: {
            '$ref': '#/components/schemas/NodePackageType'
        },
        debug: {
            type: 'boolean'
        },
        legacy: {
            type: 'string',
            description: 'Filter by release schema version. "true" returns only v1 (legacy) releases. "false" returns only v2+ releases. Omit to return all releases.',
            example: 'false'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedTenantReleasesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/TenantReleaseFilters'
        },
        sort: {
            '$ref': '#/components/schemas/ReleaseSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedTenantReleasesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantReleaseListItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedTenantReleasesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TenantReleaseResponse = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        version: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            nullable: true,
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            type: 'string',
            nullable: true,
            description: 'Node architecture',
            example: 'amd64',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        targetOs: {
            type: 'string',
            nullable: true,
            description: 'Target operating system',
            example: 'linux',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageType: {
            type: 'string',
            nullable: true,
            description: 'Package type',
            example: 'deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateReleased: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        package: {
            type: 'string',
            nullable: true,
            example: 'node-v1.2.3-linux-amd64.deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSha256: {
            type: 'string',
            nullable: true,
            example: 'abc123...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSizeBytes: {
            type: 'integer',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageUrl: {
            type: 'string',
            description: 'Signed URL for downloading the package (expires in 1 hour)',
            example: 'https://storage.googleapis.com/signed/node-v1.2.3-windows-amd64.msi',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'version', 'buildNumber', 'schemaVersion', 'architecture', 'targetOs', 'packageType', 'dateReleased', 'debug', 'package', 'packageSha256', 'packageSizeBytes', 'packageUrl'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantReleaseResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/TenantReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $TenantReleaseDownload = {
    type: 'object',
    properties: {
        downloadID: {
            type: 'string',
            format: 'uuid',
            description: 'UUID of the installer builder channel',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['downloadID'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TenantReleaseDownloadResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/TenantReleaseDownload'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ConfigType = {
    type: 'string',
    enum: ['default', 'scout_mode'],
    example: 'default',
    'x-enum-varnames': ['ConfigTypeDefault', 'ConfigTypeScoutMode'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=default scout_mode'
    }
} as const;

export const $DownloadTenantReleaseRequestSchema = {
    type: 'object',
    properties: {
        debugBuild: {
            type: 'boolean',
            default: false
        },
        configType: {
            '$ref': '#/components/schemas/ConfigType'
        }
    },
    additionalProperties: false
} as const;

export const $NotificationSubjectData = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Sales App Server'
        },
        nodeId: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000'
        },
        hostname: {
            type: 'string',
            example: 'apnyc-dc-001'
        },
        userId: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000'
        },
        updatedBy: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000'
        },
        displayName: {
            type: 'string',
            example: 'Mary Smith'
        },
        role: {
            type: 'string',
            example: 'admin'
        },
        reason: {
            type: 'string',
            example: 'Clearing hallmarks for testing'
        },
        createdBy: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $Notification = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        type: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        title: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtitle: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subjectData: {
            '$ref': '#/components/schemas/NotificationSubjectData'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateOfEvent: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        urgency: {
            type: 'string',
            enum: ['informational', 'important', 'critical'],
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,oneof=informational important critical'
            }
        }
    },
    required: ['id', 'tenantID', 'type', 'title', 'subtitle', 'subjectData', 'dateCreated', 'dateOfEvent'],
    additionalProperties: false
} as const;

export const $NotificationFilters = {
    type: 'object',
    properties: {
        entityId: {
            type: 'string',
            format: 'uuid',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NotificationSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedNotificationsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NotificationFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NotificationSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNotificationsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/Notification'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNotificationsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ArchType = {
    type: 'string',
    enum: ['x86_64', 'arm64'],
    example: 'x86_64',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=x86_64 arm64'
    }
} as const;

export const $OsType = {
    type: 'string',
    enum: ['windows', 'linux', 'macos'],
    example: 'windows',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=windows linux macos'
    }
} as const;

export const $CliDownload = {
    type: 'object',
    properties: {
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        ArchType: {
            '$ref': '#/components/schemas/ArchType'
        },
        OsType: {
            '$ref': '#/components/schemas/OsType'
        },
        buildId: {
            type: 'string',
            description: 'unique identifier of build',
            example: 'abcdef',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildVersion: {
            type: 'string',
            description: 'version of build',
            example: 'v1.0.0',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildDate: {
            type: 'string',
            description: 'date of build',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        expiresIn: {
            type: 'integer',
            description: 'seconds until download URL expires',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        downloadUrl: {
            type: 'string',
            format: 'uri',
            description: '',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tenantID', 'ArchType', 'OsType', 'buildId', 'buildVersion', 'buildDate', 'expiresIn', 'downloadUrl'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CliDownloadResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CliDownload'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CliVersion = {
    type: 'object',
    properties: {
        version: {
            type: 'string',
            description: 'semantic version of latest build',
            example: 'v1.0.0',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['version'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CliVersionResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CliVersion'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CredentialRotation = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'NodeID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CredentialRotationResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CredentialRotation'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ProvisioningCredentials = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        private_key_pem: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        certificate_pem: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'private_key_pem', 'certificate_pem'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CreateProvisioningCredentialsResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ProvisioningCredentials'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateProvisioningCredentials = {
    type: 'object',
    properties: {
        quota: {
            type: 'integer',
            minimum: 0,
            maximum: 1000,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0,max=1000'
            }
        },
        lifetimeDays: {
            type: 'integer',
            minimum: 1,
            maximum: 365,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=365'
            }
        }
    },
    required: ['quota', 'lifetimeDays'],
    additionalProperties: false
} as const;

export const $UpdateProvisioningQuotaResponse = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        quota: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'quota'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $QuotaUpdateResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/UpdateProvisioningQuotaResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $UpdateProvisioningQuota = {
    type: 'object',
    properties: {
        quota: {
            type: 'integer',
            minimum: 0,
            maximum: 1000,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0,max=1000'
            }
        }
    },
    required: ['quota'],
    additionalProperties: false
} as const;

export const $AlertConfig = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-go-name': 'tenantID',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        type: {
            type: 'string',
            enum: ['slack', 'exabeam', 'splunk'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=slack exabeam splunk'
            }
        },
        config: {
            anyOf: [
                {
                    type: 'object',
                    properties: {
                        slackWebhook: {
                            type: 'string',
                            example: 'https://hooks.slack.com/...'
                        }
                    },
                    required: ['slackWebhook']
                },
                {
                    type: 'object',
                    properties: {
                        exabeamWebhook: {
                            type: 'string',
                            example: 'https://exabeam.com/...'
                        },
                        exabeamToken: {
                            type: 'string',
                            example: 'exabeam-token123'
                        }
                    },
                    required: ['exabeamWebhook', 'exabeamToken']
                },
                {
                    type: 'object',
                    properties: {
                        splunkWebhook: {
                            type: 'string',
                            example: 'https://splunk.com/...'
                        },
                        splunkToken: {
                            type: 'string',
                            example: 'splunk-token123'
                        },
                        disableTlsVerification: {
                            type: 'boolean',
                            default: false,
                            example: true
                        }
                    },
                    required: ['splunkWebhook', 'splunkToken']
                }
            ],
            description: 'Alert configuration fields'
        },
        name: {
            type: 'string',
            maxLength: 255,
            example: 'Critical Alerts',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,max=255'
            }
        },
        description: {
            type: 'string',
            nullable: true,
            maxLength: 1000,
            example: 'Alerts for critical events',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,max=1000'
            }
        },
        eventTypes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['hallmark', 'deflection', 'lifecycle', 'signal']
            },
            example: ['hallmark', 'deflection'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=hallmark deflection lifecycle signal'
            }
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            example: [],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeDetails: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: ['id', 'name']
            },
            example: []
        },
        keyValueFilters: {
            type: 'object',
            properties: {
                include: {
                    type: 'object',
                    additionalProperties: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'number'
                            },
                            {
                                type: 'boolean'
                            }
                        ]
                    }
                },
                exclude: {
                    type: 'object',
                    additionalProperties: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'number'
                            },
                            {
                                type: 'boolean'
                            }
                        ]
                    }
                }
            },
            description: 'Filters for matching payload key-value pairs using nested format with "include" and "exclude" objects. Values can be strings, numbers, or booleans (all converted to strings for case-insensitive substring matching). Include filters: all must match. Exclude filters: none can match.',
            examples: [
                {
                    include: {
                        severity: 'high',
                        rule_id: 10008
                    }
                },
                {
                    exclude: {
                        class: 'NEW_CONFIG_APPLIED',
                        enabled: false
                    }
                },
                {
                    include: {
                        severity: 'high'
                    },
                    exclude: {
                        class: 'NEW_CONFIG_APPLIED'
                    }
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        status: {
            type: 'string',
            enum: ['suspended', 'active'],
            example: 'active',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=suspended active'
            }
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            },
            example: ['node_tag_1', 'node_tag_2'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            example: '2024-01-01T00:00:00Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'tenantId', 'type', 'name', 'description', 'eventTypes', 'nodeIds', 'keyValueFilters', 'status', 'tags', 'dateCreated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $AlertConfigSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-type', '+type', '-status', '+status', '-dateCreated', '+dateCreated']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -type +type -status +status -dateCreated +dateCreated'
    },
    additionalProperties: false
} as const;

export const $ListAlertsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            type: 'object',
            properties: {},
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        sort: {
            '$ref': '#/components/schemas/AlertConfigSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ListAlertsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AlertConfig'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/ListAlertsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $AlertConfigResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/AlertConfig'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $SlackConfig = {
    type: 'object',
    properties: {
        slackWebhook: {
            type: 'string',
            example: 'https://hooks.slack.com/...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['slackWebhook'],
    additionalProperties: false
} as const;

export const $ExabeamConfig = {
    type: 'object',
    properties: {
        exabeamWebhook: {
            type: 'string',
            example: 'https://exabeam.com/...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        exabeamToken: {
            type: 'string',
            example: 'exabeam-token123',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['exabeamWebhook', 'exabeamToken'],
    additionalProperties: false
} as const;

export const $SplunkConfig = {
    type: 'object',
    properties: {
        splunkWebhook: {
            type: 'string',
            example: 'https://splunk.com/...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        splunkToken: {
            type: 'string',
            example: 'splunk-token123',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        disableTlsVerification: {
            type: 'boolean',
            default: false,
            example: true
        }
    },
    required: ['splunkWebhook', 'splunkToken'],
    additionalProperties: false
} as const;

export const $AlertConfigRequest = {
    oneOf: [
        {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['slack']
                },
                config: {
                    '$ref': '#/components/schemas/SlackConfig'
                },
                name: {
                    type: 'string',
                    maxLength: 255,
                    example: 'Critical Alerts'
                },
                description: {
                    type: 'string',
                    maxLength: 1000,
                    example: 'Alerts for critical events'
                },
                eventTypes: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: ['hallmark', 'deflection', 'lifecycle', 'signal']
                    },
                    minItems: 1,
                    example: ['hallmark', 'deflection']
                },
                nodeIds: {
                    type: 'array',
                    items: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    example: []
                },
                keyValueFilters: {
                    type: 'object',
                    properties: {
                        include: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        },
                        exclude: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        }
                    },
                    description: 'Filters for matching payload key-value pairs using nested format with "include" and "exclude" objects. Values can be strings, numbers, or booleans (all converted to strings for case-insensitive substring matching). Include filters: all must match. Exclude filters: none can match.',
                    examples: [
                        {
                            include: {
                                severity: 'high',
                                rule_id: 10008
                            }
                        },
                        {
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED',
                                enabled: false
                            }
                        },
                        {
                            include: {
                                severity: 'high'
                            },
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED'
                            }
                        }
                    ]
                },
                status: {
                    type: 'string',
                    enum: ['suspended', 'active'],
                    default: 'active',
                    example: 'active'
                },
                tags: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    default: [],
                    example: ['node_tag_1', 'node_tag_2']
                }
            },
            required: ['type', 'config', 'name', 'eventTypes'],
            'x-go-type-name': 'AlertConfigSlack'
        },
        {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['exabeam']
                },
                config: {
                    '$ref': '#/components/schemas/ExabeamConfig'
                },
                name: {
                    type: 'string',
                    maxLength: 255,
                    example: 'Critical Alerts'
                },
                description: {
                    type: 'string',
                    maxLength: 1000,
                    example: 'Alerts for critical events'
                },
                eventTypes: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: ['hallmark', 'deflection', 'lifecycle', 'signal']
                    },
                    minItems: 1,
                    example: ['hallmark', 'deflection']
                },
                nodeIds: {
                    type: 'array',
                    items: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    example: []
                },
                keyValueFilters: {
                    type: 'object',
                    properties: {
                        include: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        },
                        exclude: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        }
                    },
                    description: 'Filters for matching payload key-value pairs using nested format with "include" and "exclude" objects. Values can be strings, numbers, or booleans (all converted to strings for case-insensitive substring matching). Include filters: all must match. Exclude filters: none can match.',
                    examples: [
                        {
                            include: {
                                severity: 'high',
                                rule_id: 10008
                            }
                        },
                        {
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED',
                                enabled: false
                            }
                        },
                        {
                            include: {
                                severity: 'high'
                            },
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED'
                            }
                        }
                    ]
                },
                status: {
                    type: 'string',
                    enum: ['suspended', 'active'],
                    default: 'active',
                    example: 'active'
                },
                tags: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    default: [],
                    example: ['node_tag_1', 'node_tag_2']
                }
            },
            required: ['type', 'config', 'name', 'eventTypes'],
            'x-go-type-name': 'AlertConfigExabeam'
        },
        {
            type: 'object',
            properties: {
                type: {
                    type: 'string',
                    enum: ['splunk']
                },
                config: {
                    '$ref': '#/components/schemas/SplunkConfig'
                },
                name: {
                    type: 'string',
                    maxLength: 255,
                    example: 'Critical Alerts'
                },
                description: {
                    type: 'string',
                    maxLength: 1000,
                    example: 'Alerts for critical events'
                },
                eventTypes: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: ['hallmark', 'deflection', 'lifecycle', 'signal']
                    },
                    minItems: 1,
                    example: ['hallmark', 'deflection']
                },
                nodeIds: {
                    type: 'array',
                    items: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    example: []
                },
                keyValueFilters: {
                    type: 'object',
                    properties: {
                        include: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        },
                        exclude: {
                            type: 'object',
                            additionalProperties: {
                                anyOf: [
                                    {
                                        type: 'string'
                                    },
                                    {
                                        type: 'number'
                                    },
                                    {
                                        type: 'boolean'
                                    }
                                ]
                            }
                        }
                    },
                    description: 'Filters for matching payload key-value pairs using nested format with "include" and "exclude" objects. Values can be strings, numbers, or booleans (all converted to strings for case-insensitive substring matching). Include filters: all must match. Exclude filters: none can match.',
                    examples: [
                        {
                            include: {
                                severity: 'high',
                                rule_id: 10008
                            }
                        },
                        {
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED',
                                enabled: false
                            }
                        },
                        {
                            include: {
                                severity: 'high'
                            },
                            exclude: {
                                class: 'NEW_CONFIG_APPLIED'
                            }
                        }
                    ]
                },
                status: {
                    type: 'string',
                    enum: ['suspended', 'active'],
                    default: 'active',
                    example: 'active'
                },
                tags: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    default: [],
                    example: ['node_tag_1', 'node_tag_2']
                }
            },
            required: ['type', 'config', 'name', 'eventTypes'],
            'x-go-type-name': 'AlertConfigSplunk'
        }
    ],
    additionalProperties: false
} as const;

export const $AlertConfigUpdateRequest = {
    type: 'object',
    properties: {
        config: {
            type: 'object',
            additionalProperties: {
                nullable: true
            },
            example: {
                slackWebhook: 'https://hooks.slack.com/...'
            }
        },
        name: {
            type: 'string',
            maxLength: 255,
            example: 'Critical Alerts',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,max=255'
            }
        },
        description: {
            type: 'string',
            maxLength: 1000,
            example: 'Alerts for critical events',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,max=1000'
            }
        },
        eventTypes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['hallmark', 'deflection', 'lifecycle', 'signal']
            },
            minItems: 1,
            example: ['hallmark', 'deflection'],
            'x-oapi-codegen-extra-tags': {
                validate: 'oneof=hallmark deflection lifecycle signal'
            }
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            example: []
        },
        keyValueFilters: {
            type: 'object',
            properties: {
                include: {
                    type: 'object',
                    additionalProperties: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'number'
                            },
                            {
                                type: 'boolean'
                            }
                        ]
                    }
                },
                exclude: {
                    type: 'object',
                    additionalProperties: {
                        anyOf: [
                            {
                                type: 'string'
                            },
                            {
                                type: 'number'
                            },
                            {
                                type: 'boolean'
                            }
                        ]
                    }
                }
            },
            description: 'Filters for matching payload key-value pairs using nested format with "include" and "exclude" objects. Values can be strings, numbers, or booleans (all converted to strings for case-insensitive substring matching). Include filters: all must match. Exclude filters: none can match.',
            examples: [
                {
                    include: {
                        severity: 'high',
                        rule_id: 10008
                    }
                },
                {
                    exclude: {
                        class: 'NEW_CONFIG_APPLIED',
                        enabled: false
                    }
                },
                {
                    include: {
                        severity: 'high'
                    },
                    exclude: {
                        class: 'NEW_CONFIG_APPLIED'
                    }
                }
            ]
        },
        status: {
            type: 'string',
            enum: ['suspended', 'active'],
            example: 'active',
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,oneof=suspended active'
            }
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            },
            example: ['node_tag_1', 'node_tag_2']
        }
    },
    additionalProperties: false
} as const;

export const $AlertResponse = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        alertConfigId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'AlertConfigID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        telemetryId: {
            type: 'string',
            description: 'Telemetry ID',
            'x-go-name': 'TelemetryID',
            example: 'test-018e1234-5678-9abc-def0-123456789abc',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        telemetryType: {
            type: 'string',
            description: 'Type of event that triggered this alert',
            example: 'hallmark',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        isTest: {
            type: 'boolean',
            description: 'Whether this is a test alert response',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        statusCode: {
            type: 'integer',
            nullable: true,
            description: 'HTTP status code from webhook',
            example: 200,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        error: {
            type: 'boolean',
            example: false,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        errorMessage: {
            type: 'string',
            nullable: true,
            description: 'Error message if request failed',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        responseBody: {
            type: 'string',
            nullable: true,
            description: 'Response body from webhook as string',
            example: 'Request limit exceeded.',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            example: '2026-05-06T12:00:00Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'alertConfigId', 'telemetryId', 'telemetryType', 'isTest', 'statusCode', 'error', 'errorMessage', 'responseBody', 'dateCreated'],
    additionalProperties: false
} as const;

export const $AlertResponseFilters = {
    type: 'object',
    properties: {
        telemetryId: {
            type: 'string',
            description: 'Filter by telemetry ID'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $AlertResponseSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-dateCreated', '+dateCreated']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-dateCreated +dateCreated'
    },
    additionalProperties: false
} as const;

export const $ListAlertResponsesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/AlertResponseFilters'
        },
        sort: {
            '$ref': '#/components/schemas/AlertResponseSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ListAlertResponsesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/AlertResponse'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/ListAlertResponsesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TestAlertData = {
    type: 'object',
    properties: {
        testId: {
            type: 'string',
            description: 'Test ID for filtering responses',
            example: 'test-018e1234-5678-9abc-def0-123456789abc',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        status: {
            type: 'string',
            enum: ['queued'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=queued'
            }
        },
        message: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['testId', 'status', 'message'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TestAlertResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/TestAlertData'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $TestAlertRequest = {
    type: 'object',
    properties: {
        eventType: {
            type: 'string',
            enum: ['hallmark', 'deflection', 'signal', 'lifecycle'],
            description: 'Type of test event to send.',
            example: 'hallmark',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=hallmark deflection signal lifecycle'
            }
        }
    },
    required: ['eventType'],
    additionalProperties: false
} as const;

export const $NodeGroup = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantID: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        name: {
            type: 'string',
            example: 'Web Servers',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        description: {
            type: 'string',
            example: 'Group containing all web server nodes'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/OsType'
        },
        nodeCount: {
            type: 'integer',
            minimum: 0,
            example: 5,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        updatedBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenant: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                tenantID: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Sales App'
                },
                badgeColor: {
                    type: 'string',
                    example: '#cecdcc'
                },
                description: {
                    type: 'string',
                    nullable: true,
                    example: 'Sales team subtenant'
                },
                childrenCount: {
                    type: 'integer',
                    minimum: 0,
                    description: 'Number of child subtenants',
                    example: 0
                },
                subtenantLevel: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 4,
                    description: 'The level of the subtenant in the hierarchy (0-4)',
                    example: 0
                }
            },
            required: ['id', 'tenantID', 'name', 'description', 'childrenCount', 'subtenantLevel']
        },
        configId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevisionId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        outOfSyncCount: {
            type: 'integer',
            minimum: 0,
            description: 'Count of nodes in the group with a different config/revision than the group',
            example: 2,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        }
    },
    required: ['id', 'tenantID', 'name', 'operatingSystem', 'nodeCount', 'dateCreated', 'dateUpdated', 'configId', 'configRevisionId', 'outOfSyncCount'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeGroupFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'web'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/OsType'
        },
        subtenantId: {
            '$ref': '#/components/schemas/UuidOrNull'
        }
    },
    example: {
        name: 'web'
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeGroupSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-operatingSystem', '+operatingSystem', '-dateCreated', '+dateCreated', '-dateUpdated', '+dateUpdated']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -operatingSystem +operatingSystem -dateCreated +dateCreated -dateUpdated +dateUpdated'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeGroupsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeGroupFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeGroupSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeGroupsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeGroup'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeGroupsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeGroupResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/NodeGroup'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateNodeGroupSchema = {
    type: 'object',
    properties: {
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        name: {
            type: 'string',
            example: 'Web Servers',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        description: {
            type: 'string',
            example: 'Group containing all web server nodes'
        },
        operatingSystem: {
            '$ref': '#/components/schemas/OsType'
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevisionId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            default: [],
            description: 'Optional array of node IDs to add to the group upon creation'
        }
    },
    required: ['name', 'operatingSystem', 'configId', 'configRevisionId'],
    additionalProperties: false
} as const;

export const $PatchNodeGroupSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Web Servers'
        },
        description: {
            type: 'string',
            example: 'Group containing all web server nodes'
        }
    },
    additionalProperties: false
} as const;

export const $AddNodesToGroupSchema = {
    type: 'object',
    properties: {
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            minItems: 1,
            description: 'Array of node IDs to add to the group',
            example: ['550e8400-e29b-41d4-a716-446655440000', '6ba7b810-9dad-11d1-80b4-00c04fd430c8'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeIds'],
    additionalProperties: false
} as const;

export const $RemoveNodesFromGroupSchema = {
    type: 'object',
    properties: {
        nodeIds: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid',
                pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
            },
            minItems: 1,
            description: 'Array of node IDs to remove from the group',
            example: ['550e8400-e29b-41d4-a716-446655440000', '6ba7b810-9dad-11d1-80b4-00c04fd430c8'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeIds'],
    additionalProperties: false
} as const;

export const $AssignConfigToGroupResultItem = {
    type: 'object',
    nullable: true,
    properties: {
        jobId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        configRevisionNumber: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['jobId', 'configId', 'configRevisionNumber'],
    description: 'Assignment result with job details, or null if the group has no nodes',
    additionalProperties: false
} as const;

export const $AssignConfigToGroupResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                nodeGroup: {
                    '$ref': '#/components/schemas/NodeGroup'
                },
                assignment: {
                    '$ref': '#/components/schemas/AssignConfigToGroupResultItem'
                }
            },
            required: ['nodeGroup', 'assignment'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $AssignConfigToGroupSchema = {
    type: 'object',
    properties: {
        configId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'The config ID to assign to the node group and its nodes',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revisionNumber: {
            type: 'integer',
            description: 'The revision number of the config to apply',
            example: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['configId', 'revisionNumber'],
    additionalProperties: false
} as const;

export const $InstallerToken = {
    type: 'object',
    properties: {
        tokenId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the installer token',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the tenant this token belongs to',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the subtenant this token is scoped to, or null for tenant-level',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeGroup: {
            type: 'object',
            nullable: true,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string'
                },
                createdBy: {
                    '$ref': '#/components/schemas/UserInfo'
                },
                dateCreated: {
                    type: 'string',
                    format: 'date-time'
                },
                configRevisionId: {
                    type: 'string',
                    nullable: true,
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                dateUpdated: {
                    type: 'string',
                    format: 'date-time'
                },
                updatedBy: {
                    '$ref': '#/components/schemas/UserInfo'
                }
            },
            required: ['id', 'name', 'createdBy', 'dateCreated', 'configRevisionId', 'dateUpdated', 'updatedBy'],
            description: 'The fleet nodes will be auto-assigned to, if any',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            description: 'Name of the installer token',
            example: 'Production Server Installer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        quotaUsed: {
            type: 'integer',
            minimum: 0,
            description: 'Number of nodes already registered with this token',
            example: 15,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=0'
            }
        },
        createdBy: {
            '$ref': '#/components/schemas/UserInfo'
        },
        dateCreated: {
            type: 'string',
            description: 'Timestamp when token was created',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revokedBy: {
            type: 'object',
            nullable: true,
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                type: {
                    type: 'string',
                    enum: ['user', 'api-token'],
                    default: 'user'
                },
                displayName: {
                    type: 'string',
                    example: 'John Doe'
                },
                email: {
                    type: 'string',
                    format: 'email',
                    example: 'john@somewhere.com'
                }
            },
            required: ['id', 'displayName', 'email'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateRevoked: {
            type: 'string',
            nullable: true,
            description: 'Timestamp when token was revoked',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tokenId', 'tenantId', 'subtenantId', 'nodeGroup', 'name', 'quotaUsed', 'createdBy', 'dateCreated', 'revokedBy', 'dateRevoked'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $InstallerTokenFilters = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        revoked: {
            type: 'boolean'
        },
        subtenantId: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UuidOrNull'
                },
                {
                    description: 'Filter tokens by subtenant UUID, or null for tenant-level tokens only'
                }
            ]
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $InstallerTokenSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-name', '+name', '-dateCreated', '+dateCreated', '-quotaUsed', '+quotaUsed']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-name +name -dateCreated +dateCreated -quotaUsed +quotaUsed'
    },
    additionalProperties: false
} as const;

export const $PaginatedInstallerTokensResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/InstallerTokenFilters'
        },
        sort: {
            '$ref': '#/components/schemas/InstallerTokenSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedInstallerTokensResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/InstallerToken'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedInstallerTokensResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $InstallerTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/InstallerToken'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateInstallerTokenData = {
    type: 'object',
    properties: {
        tokenId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the installer token',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the tenant this token belongs to',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subtenantId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the subtenant this token is scoped to, or null for tenant-level',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeGroupId: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the fleet nodes will be assigned to, or null for no automatic fleet assignment',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        token: {
            type: 'string',
            description: 'JWT token for node installation (one-time display only, not stored)',
            example: 'eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tokenId', 'tenantId', 'subtenantId', 'nodeGroupId', 'token'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $CreateInstallerTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/CreateInstallerTokenData'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateInstallerTokenRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            description: 'Name for the installer token',
            example: 'Production Server Installer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=100'
            }
        },
        subtenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'Optional subtenant UUID. Nodes installed with this token will be scoped to this subtenant.'
        },
        nodeGroupId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'Optional fleet UUID. Nodes installed with this token will be automatically assigned to this fleet when eligible.'
        }
    },
    required: ['name'],
    additionalProperties: false
} as const;

export const $RevokeInstallerTokenData = {
    type: 'object',
    properties: {
        tokenId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the installer token',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            description: 'UUID of the tenant this token belongs to',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            description: 'Name of the installer token',
            example: 'Production Server Installer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tokenId', 'tenantId', 'name'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $RevokeInstallerTokenResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/RevokeInstallerTokenData'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateOauthClientResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    example: 'Support Application'
                },
                redirectUris: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    minItems: 1
                },
                clientSecret: {
                    type: 'string',
                    description: 'Secret used by the oauth client. This secret will only be returned on `create` and should be kept in a safe place'
                },
                clientId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    example: '550e8400-e29b-41d4-a716-446655440000'
                },
                tenantId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    example: '550e8400-e29b-41d4-a716-446655440000'
                }
            },
            required: ['id', 'name', 'redirectUris', 'clientSecret', 'clientId', 'tenantId'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateOauthClientRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Support Application',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        redirectUris: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        idTokenSignatureAlg: {
            type: 'string'
        }
    },
    required: ['name', 'redirectUris'],
    additionalProperties: false
} as const;

export const $OauthClientResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                name: {
                    type: 'string',
                    minLength: 1
                },
                redirectUris: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    minItems: 1
                },
                tenantId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                clientId: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                },
                confidential: {
                    type: 'boolean'
                },
                supportedGrantTypes: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    minItems: 1
                },
                accessTokenTtl: {
                    type: 'number'
                },
                authorizationCodeTtl: {
                    type: 'number'
                },
                refreshTokenTtl: {
                    type: 'number'
                },
                pkce: {
                    type: 'boolean'
                },
                metadata: {
                    type: 'object',
                    properties: {}
                },
                publicKey: {
                    type: 'string'
                },
                idTokenSignatureAlg: {
                    type: 'string'
                }
            },
            required: ['id', 'name', 'redirectUris', 'tenantId', 'clientId', 'confidential', 'supportedGrantTypes', 'accessTokenTtl', 'authorizationCodeTtl', 'refreshTokenTtl', 'pkce', 'metadata', 'publicKey', 'idTokenSignatureAlg'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $OauthClientSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-id', '+id', '-name', '+name', '-redirectUris', '+redirectUris', '-tenantId', '+tenantId']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-id +id -name +name -redirectUris +redirectUris -tenantId +tenantId'
    },
    additionalProperties: false
} as const;

export const $PaginatedOauthClientsResponseSchemaMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    example: 'Sales App'
                }
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        sort: {
            '$ref': '#/components/schemas/OauthClientSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedOauthClientsResponseSchema = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    name: {
                        type: 'string',
                        minLength: 1
                    },
                    redirectUris: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        minItems: 1
                    },
                    tenantId: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    clientId: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
                    },
                    confidential: {
                        type: 'boolean'
                    },
                    supportedGrantTypes: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        minItems: 1
                    },
                    accessTokenTtl: {
                        type: 'number'
                    },
                    authorizationCodeTtl: {
                        type: 'number'
                    },
                    refreshTokenTtl: {
                        type: 'number'
                    },
                    pkce: {
                        type: 'boolean'
                    },
                    metadata: {
                        type: 'object',
                        properties: {}
                    },
                    publicKey: {
                        type: 'string'
                    },
                    idTokenSignatureAlg: {
                        type: 'string'
                    }
                },
                required: ['id', 'name', 'redirectUris', 'tenantId', 'clientId', 'confidential', 'supportedGrantTypes', 'accessTokenTtl', 'authorizationCodeTtl', 'refreshTokenTtl', 'pkce', 'metadata', 'publicKey', 'idTokenSignatureAlg']
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedOauthClientsResponseSchemaMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $UpdateOauthClientRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            example: 'Support Application'
        },
        redirectUris: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1
        }
    },
    additionalProperties: false
} as const;

export const $OauthTokenResponseSchema = {
    type: 'object',
    properties: {
        access_token: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        expires_in: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        id_token: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        scope: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        refresh_token: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        token_type: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        }
    },
    required: ['access_token', 'expires_in', 'id_token', 'scope', 'refresh_token', 'token_type'],
    additionalProperties: false
} as const;

export const $OauthTokenRequestSchema = {
    type: 'object',
    properties: {
        grant_type: {
            type: 'string',
            enum: ['client_credentials', 'authorization_code', 'refresh_token'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=client_credentials authorization_code refresh_token'
            }
        },
        redirect_uri: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        code: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        code_verifier: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        client_id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: 'C8524635-D25D-4215-8BCB-136C27A0C998',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        client_secret: {
            type: 'string'
        }
    },
    required: ['grant_type', 'redirect_uri', 'code', 'code_verifier', 'client_id'],
    additionalProperties: false
} as const;

export const $OauthUserinfoResponseSchema = {
    type: 'object',
    properties: {
        sub: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        },
        name: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1'
            }
        },
        given_name: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1'
            }
        },
        family_name: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1'
            }
        },
        email: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'omitempty,min=1'
            }
        }
    },
    required: ['sub'],
    additionalProperties: false
} as const;

export const $DiscoveryResponseSchema = {
    type: 'object',
    properties: {
        issuer: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        authorization_endpoint: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        token_endpoint: {
            type: 'string',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        userinfo_endpoint: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        revocation_endpoint: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        introspection_endpoint: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        subject_types_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        id_token_signing_alg_values_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        response_types_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        grant_types_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        scopes_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        token_endpoint_auth_methods_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        code_challenge_methods_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        claims_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        ui_locales_supported: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        claims_parameter_supported: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        request_parameter_supported: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        request_uri_parameter_supported: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        jwks_uri: {
            type: 'string',
            minLength: 1,
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1'
            }
        }
    },
    required: ['issuer', 'authorization_endpoint', 'token_endpoint', 'userinfo_endpoint', 'revocation_endpoint', 'introspection_endpoint', 'subject_types_supported', 'id_token_signing_alg_values_supported', 'response_types_supported', 'grant_types_supported', 'scopes_supported', 'token_endpoint_auth_methods_supported', 'code_challenge_methods_supported', 'claims_supported', 'ui_locales_supported', 'claims_parameter_supported', 'request_parameter_supported', 'request_uri_parameter_supported', 'jwks_uri'],
    additionalProperties: false
} as const;

export const $NodeReleaseTier = {
    type: 'string',
    enum: ['builds', 'releases', 'pre-ga', 'ga'],
    example: 'ga',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=builds releases pre-ga ga'
    }
} as const;

export const $NodeReleaseListItem = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: 'C8524635-D25D-4215-8BCB-136C27A0C998',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        platform: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        tier: {
            '$ref': '#/components/schemas/NodeReleaseTier'
        },
        version: {
            type: 'string',
            example: 'v1.2.3',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        releaseUuid: {
            type: 'string',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            type: 'string',
            example: 'amd64',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        package: {
            type: 'string',
            example: 'node-v1.2.3-linux-amd64.deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageType: {
            type: 'string',
            nullable: true,
            example: 'deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSha256: {
            type: 'string',
            nullable: true,
            example: 'abc123...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSizeBytes: {
            type: 'integer',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        releasedAt: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        discoveredAt: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastUpdatedAt: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'platform', 'tier', 'version', 'buildNumber', 'schemaVersion', 'releaseUuid', 'architecture', 'debug', 'package', 'packageType', 'packageSha256', 'packageSizeBytes', 'releasedAt', 'discoveredAt', 'lastUpdatedAt'],
    additionalProperties: false
} as const;

export const $NodeReleaseFilters = {
    type: 'object',
    properties: {
        platform: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        version: {
            type: 'string'
        },
        architecture: {
            type: 'string'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeReleaseSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-version', '+version']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-version +version'
    },
    additionalProperties: false
} as const;

export const $PaginatedNodeReleasesResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/NodeReleaseFilters'
        },
        sort: {
            '$ref': '#/components/schemas/NodeReleaseSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedNodeReleasesResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/NodeReleaseListItem'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedNodeReleasesResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $NodeReleaseResponse = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: 'C8524635-D25D-4215-8BCB-136C27A0C998',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        platform: {
            '$ref': '#/components/schemas/NodeOperatingSystem'
        },
        tier: {
            '$ref': '#/components/schemas/NodeReleaseTier'
        },
        version: {
            type: 'string',
            example: 'v1.2.3',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        buildNumber: {
            type: 'string',
            nullable: true,
            example: '779',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        schemaVersion: {
            type: 'string',
            example: 'v2',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        releaseUuid: {
            type: 'string',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        architecture: {
            type: 'string',
            example: 'amd64',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        debug: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        package: {
            type: 'string',
            example: 'node-v1.2.3-linux-amd64.deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageType: {
            type: 'string',
            nullable: true,
            example: 'deb',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSha256: {
            type: 'string',
            nullable: true,
            example: 'abc123...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageSizeBytes: {
            type: 'integer',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        releasedAt: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        discoveredAt: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastUpdatedAt: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        packageUrl: {
            type: 'string',
            description: 'Signed URL for downloading the package (expires in 1 hour)',
            example: 'https://storage.googleapis.com/...',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        scoutModeConfig: {
            type: 'string',
            description: 'Scout mode configuration content',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'platform', 'tier', 'version', 'buildNumber', 'schemaVersion', 'releaseUuid', 'architecture', 'debug', 'package', 'packageType', 'packageSha256', 'packageSizeBytes', 'releasedAt', 'discoveredAt', 'lastUpdatedAt', 'packageUrl', 'scoutModeConfig'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $NodeReleaseDetailResponseSchema = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/NodeReleaseResponse'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $NodeFeatures = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        format: 'uuid',
                        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                        example: 'C8524635-D25D-4215-8BCB-136C27A0C998'
                    },
                    slug: {
                        type: 'string'
                    },
                    version: {
                        type: 'string'
                    },
                    versionRequirement: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    inputSchema: {
                        type: 'object',
                        nullable: true,
                        additionalProperties: {
                            nullable: true
                        },
                        description: 'Json Schema for the input params of the feature'
                    }
                },
                required: ['id', 'slug', 'version', 'versionRequirement', 'description', 'inputSchema']
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $ActivityLog = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        actor: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UserInfo'
                },
                {
                    nullable: true
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenant: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$'
        },
        requestMethod: {
            type: 'string',
            example: 'GET',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        requestEndpoint: {
            type: 'string',
            example: '/api/users/profile',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        requestQueryParams: {
            type: 'object',
            nullable: true,
            additionalProperties: {
                nullable: true
            }
        },
        requestBody: {
            type: 'object',
            nullable: true,
            additionalProperties: {
                nullable: true
            }
        },
        responseStatus: {
            type: 'integer',
            example: 200,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        durationMs: {
            type: 'integer',
            example: 45,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'actor', 'requestMethod', 'requestEndpoint', 'responseStatus', 'durationMs', 'dateCreated'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ActivityLogFilters = {
    type: 'object',
    properties: {
        excludeEndpoints: {
            type: 'string',
            description: 'Comma-separated list of endpoint paths to exclude from results',
            example: '/api/activity,/api/users/profile'
        },
        actorName: {
            type: 'string',
            description: 'Filter by actor display name (partial match, case-insensitive)',
            example: 'John'
        },
        actorType: {
            type: 'string',
            description: 'Filter by actor type (single value or comma-separated list)',
            example: 'user'
        },
        endpoint: {
            type: 'string',
            description: 'Filter by request endpoint path (partial match, case-insensitive)',
            example: '/api/auth'
        },
        method: {
            type: 'string',
            description: 'Filter by HTTP request method (single value or comma-separated list)',
            example: 'POST,GET'
        },
        status: {
            type: 'string',
            description: 'Filter by HTTP response status code (single value or comma-separated list)',
            example: '200,201'
        },
        tenant: {
            type: 'string',
            description: 'Filter by tenant ID',
            example: '550e8400-e29b-41d4-a716-446655440000'
        }
    },
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $ActivityLogSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: []
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    },
    additionalProperties: false
} as const;

export const $PaginatedActivityLogsResponseMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            '$ref': '#/components/schemas/ActivityLogFilters'
        },
        sort: {
            '$ref': '#/components/schemas/ActivityLogSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedActivityLogsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/ActivityLog'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedActivityLogsResponseMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $ActivityLogResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/ActivityLog'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $TelemetryActivityRow = {
    type: 'object',
    properties: {
        nodeId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeName: {
            type: 'string',
            example: 'Sales App Server',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        nodeConnectivity: {
            '$ref': '#/components/schemas/ConnectivityState'
        },
        nodeLastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        occurrences: {
            type: 'integer',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        firstSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        lastSeen: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['nodeId', 'nodeName', 'nodeConnectivity', 'nodeLastSeen', 'occurrences', 'firstSeen', 'lastSeen'],
    additionalProperties: false
} as const;

export const $TelemetryActivityWindow = {
    type: 'string',
    enum: ['1h', '3h', '12h', '24h', '7d', '14d', '30d', 'custom'],
    example: '24h',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=1h 3h 12h 24h 7d 14d 30d custom'
    }
} as const;

export const $TelemetryActivityMeta = {
    type: 'object',
    properties: {
        hasMore: {
            type: 'boolean',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        window: {
            '$ref': '#/components/schemas/TelemetryActivityWindow'
        },
        since: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        until: {
            type: 'string',
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['hasMore', 'window', 'since', 'until'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $TelemetryActivityResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TelemetryActivityRow'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/TelemetryActivityMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $TelemetryActivitySection = {
    type: 'string',
    enum: ['hallmarks', 'deflections'],
    example: 'hallmarks',
    additionalProperties: false
} as const;

export const $TelemetryActivityWindowParam = {
    type: 'string',
    enum: ['1h', '3h', '12h', '24h', '7d', '14d', '30d'],
    example: '24h',
    additionalProperties: false
} as const;

export const $CreateM2MClientResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    'x-go-name': 'ID',
                    example: '550e8400-e29b-41d4-a716-446655440000'
                },
                name: {
                    type: 'string',
                    example: 'Internal Service'
                },
                type: {
                    type: 'string',
                    enum: ['m2m'],
                    example: 'm2m'
                },
                allowedScopes: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    example: ['nodes:read', 'nodes:update']
                },
                supportedGrantTypes: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    example: ['client_credentials']
                },
                accessTokenTtl: {
                    type: 'integer',
                    example: 86400
                },
                createdBy: {
                    type: 'string',
                    nullable: true,
                    format: 'uuid',
                    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
                    'x-go-name': 'ID'
                },
                clientSecret: {
                    type: 'string',
                    example: 'secret_value'
                }
            },
            required: ['id', 'name', 'type', 'allowedScopes', 'supportedGrantTypes', 'accessTokenTtl', 'createdBy', 'clientSecret'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateM2MClientRequest = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            maxLength: 70,
            example: 'Internal Service',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=1,max=70'
            }
        },
        allowedScopes: {
            type: 'array',
            items: {
                type: 'string'
            },
            minItems: 1,
            example: ['nodes:read', 'nodes:update'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['name', 'allowedScopes'],
    additionalProperties: false
} as const;

export const $M2MClient = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            example: 'Internal Service',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        type: {
            type: 'string',
            enum: ['m2m'],
            example: 'm2m',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,oneof=m2m'
            }
        },
        allowedScopes: {
            type: 'array',
            items: {
                type: 'string'
            },
            example: ['nodes:read', 'nodes:update'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        supportedGrantTypes: {
            type: 'array',
            items: {
                type: 'string'
            },
            example: ['client_credentials'],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        accessTokenTtl: {
            type: 'integer',
            example: 86400,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        createdBy: {
            type: 'string',
            nullable: true,
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'name', 'type', 'allowedScopes', 'supportedGrantTypes', 'accessTokenTtl', 'createdBy'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $M2MClientSortableFields = {
    type: 'array',
    items: {
        type: 'string',
        enum: ['-id', '+id', '-name', '+name']
    },
    'x-oapi-codegen-extra-tags': {
        validate: 'required,oneof=-id +id -name +name'
    },
    additionalProperties: false
} as const;

export const $PaginatedM2MClientsResponseSchemaMeta = {
    type: 'object',
    properties: {
        page: {
            '$ref': '#/components/schemas/Pagination'
        },
        filters: {
            type: 'object',
            properties: {
                name: {
                    type: 'string',
                    example: 'Internal Service'
                }
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        sort: {
            '$ref': '#/components/schemas/M2MClientSortableFields'
        }
    },
    required: ['page', 'filters', 'sort'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $PaginatedM2MClientsResponseSchema = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/M2MClient'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        meta: {
            '$ref': '#/components/schemas/PaginatedM2MClientsResponseSchemaMeta'
        }
    },
    required: ['data', 'meta'],
    additionalProperties: false
} as const;

export const $M2MClientResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/M2MClient'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $FeatureFlagState = {
    type: 'string',
    enum: ['alpha', 'beta', 'ga'],
    example: 'alpha',
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'omitempty,oneof=alpha beta ga'
    }
} as const;

export const $TenantFeatureFlag = {
    type: 'object',
    properties: {
        tenantId: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            example: '0124e053-3580-7413-9db3-67f435decf1d',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        enabledAt: {
            type: 'string',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        enabledBy: {
            allOf: [
                {
                    '$ref': '#/components/schemas/UserInfo'
                },
                {
                    nullable: true
                }
            ],
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['tenantId', 'enabledAt', 'enabledBy'],
    additionalProperties: false
} as const;

export const $FeatureFlag = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
            pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
            'x-go-name': 'ID',
            example: '550e8400-e29b-41d4-a716-446655440000',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        name: {
            type: 'string',
            minLength: 2,
            maxLength: 255,
            pattern: '^[a-z][a-z0-9_]+$',
            example: 'dark_mode',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=2,max=255'
            }
        },
        description: {
            type: 'string',
            nullable: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        state: {
            '$ref': '#/components/schemas/FeatureFlagState'
        },
        enabled: {
            type: 'boolean',
            example: true,
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        gaAt: {
            type: 'string',
            nullable: true,
            format: 'date-time',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateCreated: {
            type: 'string',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        dateUpdated: {
            type: 'string',
            format: 'date-time',
            example: '2025-01-01T00:00:00Z',
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        },
        tenants: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/TenantFeatureFlag'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['id', 'name', 'description', 'state', 'enabled', 'gaAt', 'dateCreated', 'dateUpdated', 'tenants'],
    additionalProperties: false,
    'x-oapi-codegen-extra-tags': {
        validate: 'required'
    }
} as const;

export const $FeatureFlagsListResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'array',
            items: {
                '$ref': '#/components/schemas/FeatureFlag'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $FeatureFlagResponse = {
    type: 'object',
    properties: {
        data: {
            '$ref': '#/components/schemas/FeatureFlag'
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;

export const $CreateFeatureFlag = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            minLength: 2,
            maxLength: 255,
            pattern: '^[a-z][a-z0-9_]+$',
            example: 'dark_mode',
            'x-oapi-codegen-extra-tags': {
                validate: 'required,min=2,max=255'
            }
        },
        description: {
            type: 'string'
        }
    },
    required: ['name'],
    additionalProperties: false
} as const;

export const $UpdateFeatureFlag = {
    type: 'object',
    properties: {
        description: {
            type: 'string'
        },
        state: {
            '$ref': '#/components/schemas/FeatureFlagState'
        },
        enabled: {
            type: 'boolean'
        }
    },
    additionalProperties: false
} as const;

export const $TenantFeatureFlagsResponse = {
    type: 'object',
    properties: {
        data: {
            type: 'object',
            additionalProperties: {
                type: 'boolean'
            },
            'x-oapi-codegen-extra-tags': {
                validate: 'required'
            }
        }
    },
    required: ['data'],
    additionalProperties: false
} as const;